webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function getCurrentDomain() {
  var temp = window.location.hostname.split('.');
  if (temp.length > 1) {
    return temp[+temp.length - 2];
  } else {
    return temp[0];
  }
}

function getLastSiteId() {
  return localStorage.getItem('chekt::lastSiteId');
}
function setLastSiteId(siteId) {
  return localStorage.setItem('chekt::lastSiteId', siteId);
}
function getLastEmail() {
  return localStorage.getItem('chekt::lastEmail');
}
function setLastEmail(email) {
  return localStorage.setItem('chekt::lastEmail', email);
}
function getCamerasLastZoomIndex() {
  return localStorage.getItem('chekt::camerasLastZoomIndex');
}
function setCamerasLastZoomIndex(index) {
  return localStorage.setItem('chekt::camerasLastZoomIndex', index);
}

var environment = {
  currentDomain: getCurrentDomain(),
  isProduction: null,
  isChektDomain: null,
  authClientID: null,
  authDomain: null,
  authConnection: null,
  authScope: null,
  authCookieDomain: null,
  authTargetPath: null,
  apiTargetPath: null,
  apiPrefix: null,
  operationWebUrl: null,
  dealerWebUrl: null,
  monitoringWebUrl: null,
  shareWebUrl: null,
  appWebUrl: null,
  getLastSiteId: getLastSiteId,
  setLastSiteId: setLastSiteId,
  getLastEmail: getLastEmail,
  setLastEmail: setLastEmail,
  getCamerasLastZoomIndex: getCamerasLastZoomIndex,
  setCamerasLastZoomIndex: setCamerasLastZoomIndex
};

if (environment.currentDomain === 'chekt') {
  environment.isChektDomain = true;
  environment.isProduction = true;
} else if (environment.currentDomain === 'chektdev') {
  environment.isChektDomain = true;
  environment.isProduction = false;
} else if (environment.currentDomain === 'github') {
  environment.isChektDomain = false;
  environment.isProduction = false;
} else if (environment.currentDomain === 'firebaseapp') {
  environment.isChektDomain = false;
  environment.isProduction = false;
} else if (environment.currentDomain === 'localhost') {
  environment.isChektDomain = false;
  environment.isProduction = true;
} else {
  environment.isChektDomain = false;
  environment.isProduction = false;
}

if (environment.isProduction) {
  environment.authClientID = 'bHzjpwmWpjwdOukz2h7FM2u2ND5BPKFa';
  environment.authDomain = 'chektcloud.auth0.com';
  environment.authConnection = 'Username-Password-Authentication';
  environment.authScope = 'openid offline_access';
  environment.authCookieDomain = '.chekt.com';
  environment.authTargetPath = 'account.chekt.com';
  environment.apiTargetPath = 'api.chekt.com';
  environment.apiPrefix = '/api/v1.1';
  environment.mqttTargetPath = 'nexus.chekt.com';
  environment.mqttTargetPathPort = 443;
  environment.operationWebUrl = 'https://operation.chekt.com';
  environment.dealerWebUrl = 'https://dealer.chekt.com';
  environment.monitoringWebUrl = 'https://monitoring.chekt.com';
  environment.shareWebUrl = 'https://share.chekt.com';
  environment.appWebUrl = 'https://app.chekt.com';
} else {
  environment.authClientID = 'yeJIohNks41mYAiaID29JoxsZESOpEQ8';
  environment.authDomain = 'chektdev.auth0.com';
  environment.authConnection = 'Username-Password-Authentication';
  environment.authScope = 'openid offline_access';
  environment.authCookieDomain = '.chektdev.com';
  environment.authTargetPath = 'account.chektdev.com';
  environment.apiTargetPath = 'api.chektdev.com';
  environment.apiPrefix = '/api/v1.1';
  environment.mqttTargetPath = 'commandcenter.chektdev.com';
  environment.mqttTargetPathPort = 443;
  environment.operationWebUrl = 'https://operation.chektdev.com';
  environment.dealerWebUrl = 'https://dealer.chektdev.com';
  environment.monitoringWebUrl = 'https://monitoring.chektdev.com';
  environment.shareWebUrl = 'https://share.chektdev.com';
  environment.appWebUrl = 'https://app.chektdev.com';
}

/* harmony default export */ __webpack_exports__["a"] = (environment);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ADD_TO_CART */
/* unused harmony export CHECKOUT_REQUEST */
/* unused harmony export CHECKOUT_SUCCESS */
/* unused harmony export CHECKOUT_FAILURE */
/* unused harmony export RECEIVE_PRODUCTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return GET_MYPROFILE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GET_MYPROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return GET_MYPROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return GET_MYSITES_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return GET_MYSITES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return GET_MYSITES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return GET_SITE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return GET_SITE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return GET_SITE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GET_SITE_CAMERAS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return GET_SITE_CAMERAS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return GET_SITE_CAMERAS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_SITE_CAMERA_EVENT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_SITE_CAMERA_EVENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_SITE_CAMERA_EVENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_CAMERA_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_CAMERA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_CAMERA_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_CAMERA_LIVESNAPSHOT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_CAMERA_LIVESNAPSHOT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_CAMERA_LIVESNAPSHOT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_CAMERA_THUMBNAILVIDEOS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_CAMERA_THUMBNAILVIDEOS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_CAMERA_THUMBNAILVIDEOS_FAILURE; });
/* unused harmony export GET_CAMERA_THUMBNAILVIDEO_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_CAMERA_THUMBNAILVIDEO_SUCCESS; });
/* unused harmony export GET_CAMERA_THUMBNAILVIDEO_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_SITE_MEMBERS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_SITE_MEMBERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_SITE_MEMBERS_FAILURE; });
/* unused harmony export GET_MEMBER_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_MEMBER_SUCCESS; });
/* unused harmony export GET_MEMBER_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_SITE_CONTACTS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_SITE_CONTACTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_SITE_CONTACTS_FAILURE; });
/* unused harmony export GET_CONTACT_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_CONTACT_SUCCESS; });
/* unused harmony export GET_CONTACT_FAILURE */
/* unused harmony export ADD_CONTACT */
/* unused harmony export REMOVE_CONTACT */
/* unused harmony export ADD_MEMBER */
/* unused harmony export REMOVE_MEMBER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SELECT_SITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SELECT_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SELECT_CAMERA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SELECT_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SELECT_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SELECT_THUMBNAILVIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SELECT_MEMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SELECT_CONTACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return OPEN_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return CLOSE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return ADD_LOG; });
/* unused harmony export CONNECT_MQTT_REQUEST */
/* unused harmony export CONNECT_MQTT_SUCCESS */
/* unused harmony export CONNECT_MQTT_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return MQTT_CONNECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return MQTT_DISCONNECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return MQTT_SITE_SUBSCRIBE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return MQTT_SITE_UNSUBSCRIBE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return INTERNET_CONNECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return INTERNET_DISCONNECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return API_RATELIMIT_LOCKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return API_RATELIMIT_UNLOCKED; });
var ADD_TO_CART = 'ADD_TO_CART';
var CHECKOUT_REQUEST = 'CHECKOUT_REQUEST';
var CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS';
var CHECKOUT_FAILURE = 'CHECKOUT_FAILURE';
var RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';

var GET_MYPROFILE_REQUEST = 'GET_MYPROFILE_REQUEST';
var GET_MYPROFILE_SUCCESS = 'GET_MYPROFILE_SUCCESS';
var GET_MYPROFILE_FAILURE = 'GET_MYPROFILE_FAILURE';

var GET_MYSITES_REQUEST = 'GET_MYSITES_REQUEST';
var GET_MYSITES_SUCCESS = 'GET_MYSITES_SUCCESS';
var GET_MYSITES_FAILURE = 'GET_MYSITES_FAILURE';

var GET_SITE_REQUEST = 'GET_SITE_REQUEST';
var GET_SITE_SUCCESS = 'GET_SITE_SUCCESS';
var GET_SITE_FAILURE = 'GET_SITE_FAILURE';

var GET_SITE_CAMERAS_REQUEST = 'GET_SITE_CAMERAS_REQUEST';
var GET_SITE_CAMERAS_SUCCESS = 'GET_SITE_CAMERAS_SUCCESS';
var GET_SITE_CAMERAS_FAILURE = 'GET_SITE_CAMERAS_FAILURE';

var GET_SITE_CAMERA_EVENT_REQUEST = 'GET_SITE_CAMERA_EVENT_REQUEST';
var GET_SITE_CAMERA_EVENT_SUCCESS = 'GET_SITE_CAMERA_EVENT_SUCCESS';
var GET_SITE_CAMERA_EVENT_FAILURE = 'GET_SITE_CAMERA_EVENT_FAILURE';

var GET_CAMERA_REQUEST = 'GET_CAMERA_REQUEST';
var GET_CAMERA_SUCCESS = 'GET_CAMERA_SUCCESS';
var GET_CAMERA_FAILURE = 'GET_CAMERA_FAILURE';

var GET_CAMERA_LIVESNAPSHOT_REQUEST = 'GET_CAMERA_LIVESNAPSHOT_REQUEST';
var GET_CAMERA_LIVESNAPSHOT_SUCCESS = 'GET_CAMERA_LIVESNAPSHOT_SUCCESS';
var GET_CAMERA_LIVESNAPSHOT_FAILURE = 'GET_CAMERA_LIVESNAPSHOT_FAILURE';

var GET_CAMERA_THUMBNAILVIDEOS_REQUEST = 'GET_CAMERA_THUMBNAILVIDEOS_REQUEST';
var GET_CAMERA_THUMBNAILVIDEOS_SUCCESS = 'GET_CAMERA_THUMBNAILVIDEOS_SUCCESS';
var GET_CAMERA_THUMBNAILVIDEOS_FAILURE = 'GET_CAMERA_THUMBNAILVIDEOS_FAILURE';

var GET_CAMERA_THUMBNAILVIDEO_REQUEST = 'GET_CAMERA_THUMBNAILVIDEO_REQUEST';
var GET_CAMERA_THUMBNAILVIDEO_SUCCESS = 'GET_CAMERA_THUMBNAILVIDEO_SUCCESS';
var GET_CAMERA_THUMBNAILVIDEO_FAILURE = 'GET_CAMERA_THUMBNAILVIDEO_FAILURE';

var GET_SITE_MEMBERS_REQUEST = 'GET_SITE_MEMBERS_REQUEST';
var GET_SITE_MEMBERS_SUCCESS = 'GET_SITE_MEMBERS_SUCCESS';
var GET_SITE_MEMBERS_FAILURE = 'GET_SITE_MEMBERS_FAILURE';

var GET_MEMBER_REQUEST = 'GET_MEMBER_REQUEST';
var GET_MEMBER_SUCCESS = 'GET_MEMBER_SUCCESS';
var GET_MEMBER_FAILURE = 'GET_MEMBER_FAILURE';

var GET_SITE_CONTACTS_REQUEST = 'GET_SITE_CONTACTS_REQUEST';
var GET_SITE_CONTACTS_SUCCESS = 'GET_SITE_CONTACTS_SUCCESS';
var GET_SITE_CONTACTS_FAILURE = 'GET_SITE_CONTACTS_FAILURE';

var GET_CONTACT_REQUEST = 'GET_CONTACT_REQUEST';
var GET_CONTACT_SUCCESS = 'GET_CONTACT_SUCCESS';
var GET_CONTACT_FAILURE = 'GET_CONTACT_FAILURE';

var ADD_CONTACT = 'ADD_CONTACT';
var REMOVE_CONTACT = 'REMOVE_CONTACT';
var ADD_MEMBER = 'ADD_MEMBER';
var REMOVE_MEMBER = 'REMOVE_MEMBER';

var SELECT_SITE = 'SELECT_SITE';
var SELECT_DATE = 'SELECT_DATE';
var SELECT_CAMERA = 'SELECT_CAMERA';
var SELECT_EVENT = 'SELECT_EVENT';
var SELECT_VIDEO = 'SELECT_VIDEO';
var SELECT_THUMBNAILVIDEO = 'SELECT_THUMBNAILVIDEO';
var SELECT_MEMBER = 'SELECT_MEMBER';
var SELECT_CONTACT = 'SELECT_CONTACT';

var OPEN_MENU = 'OPEN_MENU';
var CLOSE_MENU = 'CLOSE_MENU';

var ADD_LOG = 'ADD_LOG';

var CONNECT_MQTT_REQUEST = 'CONNECT_MQTT_REQUEST';
var CONNECT_MQTT_SUCCESS = 'CONNECT_MQTT_SUCCESS';
var CONNECT_MQTT_FAILURE = 'CONNECT_MQTT_FAILURE';

var MQTT_CONNECTED = 'MQTT_CONNECTED';
var MQTT_DISCONNECTED = 'MQTT_DISCONNECTED';

var MQTT_SITE_SUBSCRIBE = 'MQTT_SITE_SUBSCRIBE';
var MQTT_SITE_UNSUBSCRIBE = 'MQTT_SITE_UNSUBSCRIBE';

var INTERNET_CONNECTED = 'INTERNET_CONNECTED';
var INTERNET_DISCONNECTED = 'INTERNET_DISCONNECTED';

var API_RATELIMIT_LOCKED = 'API_RATELIMIT_LOCKED';
var API_RATELIMIT_UNLOCKED = 'API_RATELIMIT_UNLOCKED';

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);


/* harmony default export */ __webpack_exports__["a"] = ({
  encodeToBase64: function encodeToBase64(str) {
    return window.btoa(str);
  },
  decodeFromBase64: function decodeFromBase64(base64Str) {
    return window.atob(base64Str);
  },
  encodeToBase64Url: function encodeToBase64Url(str) {
    var base64Str = this.encodeToBase64(str);
    var base64Url = base64Str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return base64Url;
  },
  decodeFromBase64Url: function decodeFromBase64Url(base64Url) {
    if (base64Url.length % 4 === 2) base64Url = base64Url + '==';
    if (base64Url.length % 4 === 3) base64Url = base64Url + '=';
    var base64Str = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var str = this.decodeFromBase64(base64Str);
    return str;
  },
  capitalizeFirstLetter: function capitalizeFirstLetter(string) {
    string = string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  getUtcOffset: function getUtcOffset(timezone) {
    return __WEBPACK_IMPORTED_MODULE_0_moment_timezone__().tz(timezone).utcOffset();
  },
  getTodayBeginTimestamp: function getTodayBeginTimestamp(timezoneOffset) {
    var now = new Date();
    var timestamp = now.getTime();
    if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000;
    var localNow = new Date(timestamp);
    timestamp = Math.floor(new Date(new Date(localNow.setHours(0)).setMinutes(0)).setSeconds(0) / 1000) * 1000;
    if (timezoneOffset !== undefined) timestamp -= now.getTimezoneOffset() * 60 * 1000 + timezoneOffset * 60 * 1000;
    return timestamp;
  },
  getNowTimestamp: function getNowTimestamp(timezoneOffset) {
    var now = new Date();
    var timestamp = now.getTime();
    if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000;
    return timestamp;
  },
  getLocalTimestamp: function getLocalTimestamp(timestamp, timezoneOffset) {
    var now = new Date();
    if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000;
    return timestamp;
  },
  hasAllKeys: function hasAllKeys(obj, keys) {
    var result = false;
    if (obj instanceof Object && keys instanceof Array) {
      var undefinedKeys = [];
      keys.map(function (key) {
        if (obj[key] === undefined) undefinedKeys.push(key);
      });
      if (undefinedKeys.length === 0) result = true;else {
        console.log('utils.hasAllKeys failed');
        console.log(undefinedKeys);
      }
    } else {
      console.log('utils.hasAllKeys failed');
    }
    return result;
  }
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_environment__ = __webpack_require__(5);



var apiPath = 'https://' + __WEBPACK_IMPORTED_MODULE_1__services_environment__["a" /* default */].apiTargetPath + __WEBPACK_IMPORTED_MODULE_1__services_environment__["a" /* default */].apiPrefix;

/* harmony default export */ __webpack_exports__["a"] = ({
  getSiteCameras: function getSiteCameras(siteId) {
    var apiDetailPath = '/sites/' + siteId + '/devices/cameras';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getSiteCamera: function getSiteCamera(siteId, cameraId) {
    var apiDetailPath = '/sites/' + siteId + '/devices/' + cameraId;
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getLiveSnapshot: function getLiveSnapshot(siteId, deviceId) {
    var apiDetailPath = '/sites/' + siteId + '/devices/' + deviceId + '/snapshot';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getSiteCameraEvent: function getSiteCameraEvent(siteId, deviceId, eventId) {
    var apiDetailPath = '/sites/' + siteId + '/devices/' + deviceId + '/events/' + eventId;
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath, { 'headers': { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  createThumbnailVideo: function createThumbnailVideo(siteId, deviceId, year, month, day) {
    var apiDetailPath = '/sites/' + siteId + '/devices/' + deviceId + '/thumbnailvideos/years/' + year + '/months/' + month + '/days/' + day;
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(apiPath + apiDetailPath, {}, { 'headers': { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getThumbnailVideo: function getThumbnailVideo(siteId, deviceId, thumbnailVideoId) {
    var apiDetailPath = '/sites/' + siteId + '/devices/' + deviceId + '/thumbnailvideos/' + thumbnailVideoId + '/perdays';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath, { 'headers': { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getThumbnailVideos: function getThumbnailVideos(siteId, deviceId, stime, etime) {
    var apiDetailPath = '/sites/' + siteId + '/devices/' + deviceId + '/thumbnailvideos/stime/' + stime + '/etime/' + etime + '/perdays';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath, { 'headers': { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  }
  // updateFactoryMac: function () {
  //   let apiDetailPath = '/admin/factory/macs'
  //   Vue.http.post(apiPath + apiDetailPath, {mac: 'B827EB5236E7', entry_key: 'B591C0', model: 'CKB304'}, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  //   Vue.http.post(apiPath + apiDetailPath, {mac: 'B827EB843A52', entry_key: '22C2C0', model: 'CKB304'}, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  // }
});

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(243)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(273),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-434b25e7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_environment__ = __webpack_require__(5);



var apiPath = 'https://' + __WEBPACK_IMPORTED_MODULE_1__services_environment__["a" /* default */].apiTargetPath + __WEBPACK_IMPORTED_MODULE_1__services_environment__["a" /* default */].apiPrefix;

/* harmony default export */ __webpack_exports__["a"] = ({
  checkEmail: function checkEmail(email) {
    var apiDetailPath = '/users/find?email=' + email;
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath);
  },
  pingCloud: function pingCloud() {
    var apiDetailPath = '/users/me';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getMyProfile: function getMyProfile() {
    var apiDetailPath = '/users/me';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath, { headers: { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  }
});

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_cookie__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_functions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);





var AuthPlugin = {
  install: function install(Vue, options) {
    var idToken = null;
    var accountUrl = 'https://' + __WEBPACK_IMPORTED_MODULE_0__services_environment__["a" /* default */].authTargetPath;
    var loginUrl = accountUrl + '/login;hl=en;service=email;continue=' + window.btoa(window.location.origin + '/home');
    var loginUrlLocalStorage = accountUrl + '/login;hl=en;service=email;auth_type=local_storage;continue=' + window.btoa(window.location.origin + '/home');
    var logoutUrl = accountUrl + '/logout;hl=en;service=email;continue=' + window.btoa(window.location.origin + '/home');
    var logoutUrlLocalStorage = accountUrl + '/logout;hl=en;service=email;auth_type=local_storage;continue=' + window.btoa(window.location.origin + '/home');

    var getIdTokenFromCookie = function getIdTokenFromCookie() {
      return __WEBPACK_IMPORTED_MODULE_1__services_cookie__["a" /* default */].getCookie('chekt::id_token') ? __WEBPACK_IMPORTED_MODULE_1__services_cookie__["a" /* default */].getCookie('chekt::id_token') : null;
    };
    var getIdTokenFromLocalStorage = function getIdTokenFromLocalStorage() {
      return localStorage.getItem('chekt::id_token') ? __WEBPACK_IMPORTED_MODULE_2__services_functions__["a" /* default */].decodeFromBase64Url(localStorage.getItem('chekt::id_token')) : null;
    };
    var removeIdTokenFromLocalStorage = function removeIdTokenFromLocalStorage() {
      localStorage.removeItem('chekt::id_token');
    };
    var storeIdTokenToLocalStorage = function storeIdTokenToLocalStorage(idToken) {
      localStorage.setItem('chekt::id_token', idToken);
    };
    var tokenExpirationTimeLeft = function tokenExpirationTimeLeft(token) {
      var decodedToken = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(token);
      var now = new Date();
      return decodedToken.exp * 1000 - now.getTime();
    };

    var authenticated = function authenticated() {
      var isAuthenticated = false;
      var idToken = null;
      if (__WEBPACK_IMPORTED_MODULE_0__services_environment__["a" /* default */].isChektDomain) idToken = getIdTokenFromCookie();else idToken = getIdTokenFromLocalStorage();
      if (idToken) {
        try {
          if (+tokenExpirationTimeLeft(idToken) > 0) isAuthenticated = true;
        } catch (err) {
          isAuthenticated = false;
        }
      }
      return isAuthenticated;
    };
    var login = function login() {
      if (__WEBPACK_IMPORTED_MODULE_0__services_environment__["a" /* default */].isChektDomain) window.location.href = loginUrl;else window.location.href = loginUrlLocalStorage;
    };
    var logout = function logout() {
      if (__WEBPACK_IMPORTED_MODULE_0__services_environment__["a" /* default */].isChektDomain) window.location.href = logoutUrl;else {
        removeIdTokenFromLocalStorage();
        window.location.href = logoutUrlLocalStorage;
      }
    };

    // Login check and proper action
    if (!authenticated()) login();else {
      if (__WEBPACK_IMPORTED_MODULE_0__services_environment__["a" /* default */].isChektDomain) idToken = getIdTokenFromCookie();else idToken = getIdTokenFromLocalStorage();
      setTimeout(function () {
        login();
      }, tokenExpirationTimeLeft(idToken));
      setInterval(function () {
        if (!authenticated()) login();
      }, 1000 * 60); // check every 1 min
      console.log('New login required after ' + Math.round(tokenExpirationTimeLeft(idToken) / 1000 / 60) + ' minutes.');
    }

    var service = {
      idToken: idToken,
      authenticated: authenticated,
      login: login,
      logout: logout,
      storeIdTokenToLocalStorage: storeIdTokenToLocalStorage
    };

    Vue.prototype.$auth = service;
    Vue.auth = service;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (AuthPlugin);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Search__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Site__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Site___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Site__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Cameras__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Cameras___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Cameras__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Camera__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Camera___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Camera__);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/loading'
  }, {
    path: '/site/:siteId',
    name: 'site',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Site___default.a,
    children: [{
      path: 'cameras',
      name: 'cameras',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Cameras___default.a
    }, {
      path: 'camera/:cameraId',
      name: 'camera',
      component: __WEBPACK_IMPORTED_MODULE_7__components_Camera___default.a
    }, {
      path: '*',
      redirect: '/site/:siteId'
    }]
  }, {
    path: '/loading',
    name: 'loading',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Loading___default.a
  }, {
    path: '/search',
    name: 'search',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Search___default.a
  }, {
    path: '/home',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home___default.a
  }, {
    path: '*',
    redirect: '/loading'
  }]
}));

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rootModule__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_logger__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_mqtt__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_pingCloud__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_myProfile__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_sites__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_cameras__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_events__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_users__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_contacts__ = __webpack_require__(175);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__rootModule__["a" /* default */].state,
  actions: __WEBPACK_IMPORTED_MODULE_2__rootModule__["a" /* default */].actions,
  getters: __WEBPACK_IMPORTED_MODULE_2__rootModule__["a" /* default */].getters,
  mutations: __WEBPACK_IMPORTED_MODULE_2__rootModule__["a" /* default */].mutations,
  modules: {
    myProfile: __WEBPACK_IMPORTED_MODULE_6__modules_myProfile__["a" /* default */],
    sites: __WEBPACK_IMPORTED_MODULE_7__modules_sites__["a" /* default */],
    cameras: __WEBPACK_IMPORTED_MODULE_8__modules_cameras__["a" /* default */],
    events: __WEBPACK_IMPORTED_MODULE_9__modules_events__["a" /* default */],
    users: __WEBPACK_IMPORTED_MODULE_10__modules_users__["a" /* default */],
    contacts: __WEBPACK_IMPORTED_MODULE_11__modules_contacts__["a" /* default */]
  },
  plugins: [__WEBPACK_IMPORTED_MODULE_3__plugins_logger__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__plugins_mqtt__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__plugins_pingCloud__["a" /* default */]],
  strict: debug
}));

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(244)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(274),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */,
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_environment__ = __webpack_require__(5);



var apiPath = 'https://' + __WEBPACK_IMPORTED_MODULE_1__services_environment__["a" /* default */].apiTargetPath + __WEBPACK_IMPORTED_MODULE_1__services_environment__["a" /* default */].apiPrefix;

/* harmony default export */ __webpack_exports__["a"] = ({
  getMySites: function getMySites() {
    var apiDetailPath = '/sites';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath, { 'headers': { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getSite: function getSite(siteId) {
    var apiDetailPath = '/sites/' + siteId;
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath, { 'headers': { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getSiteCameras: function getSiteCameras(siteId) {
    var apiDetailPath = '/sites/' + siteId + '/devices/cameras';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath, { 'headers': { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getSiteMembers: function getSiteMembers(siteId) {
    var apiDetailPath = '/sites/' + siteId + '/members';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath, { 'headers': { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  },
  getSiteContacts: function getSiteContacts(siteId) {
    var apiDetailPath = '/sites/' + siteId + '/contacts';
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.get(apiPath + apiDetailPath, { 'headers': { 'Authorization': 'Bearer ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].auth.idToken } });
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_auth__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(168);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2__plugins_auth__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  setCookie: function setCookie(cname, cvalue, date, domain) {
    var cookieString = encodeURIComponent(cname) + '=' + encodeURIComponent(cvalue) + ';path=/';
    if (date) cookieString += ';expires=' + date;
    if (domain) cookieString += ';domain=' + domain;
    document.cookie = cookieString;
  },
  getCookie: function getCookie(cname) {
    var name = encodeURIComponent(cname) + '=';
    var cookie = document.cookie;
    var ca = cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return decodeURIComponent(c.substring(name.length, c.length));
      }
    }
    return '';
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_functions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_device__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(6);




var _mutations;





// initial state
var state = {
  cameras: {},
  liveSnapshot: {},
  thumbnailVideos: {},
  status: {
    getCamera: {},
    getLiveSnapshot: {},
    getThumbnailVideo: {},
    getThumbnailVideos: {}
  }

  // getters
};var getters = {
  camera: function camera(state) {
    return function (cameraId) {
      return state.cameras[cameraId];
    };
  },
  thumbnailVideo: function thumbnailVideo(state) {
    return function (thumbnailVideoId) {
      return state.thumbnailVideos[thumbnailVideoId];
    };
  },
  liveSnapshot: function liveSnapshot(state) {
    return function (cameraId) {
      return state.liveSnapshot[cameraId];
    };
  },
  statusGetLiveSnapshot: function statusGetLiveSnapshot(state) {
    return function (cameraId) {
      return state.status.getLiveSnapshot[cameraId];
    };
  }

  // actions
};var actions = {
  getThumbnailVideos: function getThumbnailVideos(_ref, _ref2) {
    var commit = _ref.commit,
        getters = _ref.getters,
        dispatch = _ref.dispatch;
    var cameraId = _ref2.cameraId;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* GET_CAMERA_THUMBNAILVIDEOS_REQUEST */], { cameraId: cameraId });
      var stime = 0;
      var etime = +getters.site(getters.camera(cameraId).siteId).todayDateId() + 60 * 60 * 24;
      __WEBPACK_IMPORTED_MODULE_4__api_device__["a" /* default */].getThumbnailVideos(getters.camera(cameraId).siteId, cameraId, stime, etime).then(function (res) {
        if (res.body instanceof Object) {
          if (__WEBPACK_IMPORTED_MODULE_3__services_functions__["a" /* default */].hasAllKeys(res.body, ['count', 'thumbnails'])) {
            if (res.body.thumbnails instanceof Array) {
              var thumbnailVideos = {};
              res.body.thumbnails.map(function (thumbnail) {
                var isDataValid = false;
                if (__WEBPACK_IMPORTED_MODULE_3__services_functions__["a" /* default */].hasAllKeys(thumbnail, ['duration_time', 'thumbnail_records', 'timestamp', 'url'])) {
                  var dateId = thumbnail.timestamp;
                  var timeDiff = +getters.site(getters.camera(cameraId).siteId).todayDateId() - dateId;
                  if (timeDiff % (60 * 60 * 24) === 0) {
                    if (thumbnail.thumbnail_records instanceof Object) {
                      if (__WEBPACK_IMPORTED_MODULE_3__services_functions__["a" /* default */].hasAllKeys(thumbnail.thumbnail_records, ['count'])) {
                        isDataValid = true;
                      }
                    }
                  } else console.log('incorrect timestamp');
                  if (isDataValid) {
                    var thumbnailVideoId = cameraId + '-' + dateId;
                    thumbnailVideos[dateId] = thumbnailVideoId;
                    // console.log(timeDiff / 60 / 60 / 24 + ' days ago')
                    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* GET_CAMERA_THUMBNAILVIDEO_SUCCESS */], {
                      thumbnailVideoId: thumbnailVideoId,
                      thumbnailVideo: {
                        thumbnailVideoId: thumbnailVideoId,
                        dateId: dateId,
                        url: thumbnail.url,
                        isThumbnailVideoCreated: thumbnail.url ? 1 : 0,
                        hasMissingThumbnail: thumbnail.thumbnail_records.count !== 1440 ? 1 : 0,
                        hasThumbnailRecords: thumbnail.thumbnail_records.count ? 1 : 0,
                        thumbnailRecords: thumbnail.thumbnail_records
                      }
                    });
                  }
                }
              });
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* GET_CAMERA_THUMBNAILVIDEOS_SUCCESS */], {
                cameraId: cameraId,
                thumbnailVideos: thumbnailVideos
              });
            } else {
              console.log('getThumbnailVideos failed');
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* GET_CAMERA_THUMBNAILVIDEOS_FAILURE */], { cameraId: cameraId });
              reject({
                status: res.status,
                statusText: res.statusText,
                body: res.body,
                successButText: 'incorrect api response'
              });
            }
          } else {
            console.log('getThumbnailVideos failed');
            commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* GET_CAMERA_THUMBNAILVIDEOS_FAILURE */], { cameraId: cameraId });
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            });
          }
        } else {
          console.log('getThumbnailVideos failed');
          commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* GET_CAMERA_THUMBNAILVIDEOS_FAILURE */], { cameraId: cameraId });
          reject({
            status: res.status,
            statusText: res.statusText,
            body: res.body,
            successButText: 'incorrect api response'
          });
        }
      }, function (err) {
        console.log(err);
        dispatch('checkOnlineStatusByApiResponse', err);
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* GET_CAMERA_THUMBNAILVIDEOS_FAILURE */], { cameraId: cameraId });
        reject({
          status: err.status,
          statusText: err.statusText,
          body: err.body
        });
      });
    });
  },
  getSiteCamera: function getSiteCamera(_ref3, cameraId) {
    var commit = _ref3.commit,
        getters = _ref3.getters,
        dispatch = _ref3.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* GET_CAMERA_REQUEST */], { cameraId: cameraId });
      __WEBPACK_IMPORTED_MODULE_4__api_device__["a" /* default */].getSiteCamera(getters.camera(cameraId).siteId, cameraId).then(function (res) {
        if (res.body[0] instanceof Object) {
          if (__WEBPACK_IMPORTED_MODULE_3__services_functions__["a" /* default */].hasAllKeys(res.body[0], ['device_id', 'alarm_zone', 'trouble_zone', 'name', 'mac', 'type', 'channel', 'model', 'is_privacy', 'privacy_disabled_duration', 'privacy_disabled_timestamp', 'is_activated', 'is_online', 'is_online_update_time', 'is_cont_recording', 'firmware_update_status', 'is_registered', 'position_metadata', 'privacy_background_image_url', 'private_ip', 'public_ip', 'stream_url'])) {
            commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["k" /* GET_CAMERA_SUCCESS */], {
              siteId: getters.camera(cameraId).siteId,
              cameraId: res.body[0].device_id,
              alarmZone: res.body[0].alarm_zone,
              troubleZone: res.body[0].trouble_zone,
              name: res.body[0].name,
              mac: res.body[0].mac,
              type: res.body[0].type,
              channel: res.body[0].channel,
              model: res.body[0].model,
              isPrivacyEnabled: res.body[0].is_privacy,
              privacyDisabledDuration: res.body[0].privacy_disabled_duration,
              privacyDisabledTimestamp: res.body[0].privacy_disabled_timestamp,
              isActivated: res.body[0].is_activated,
              isOnline: res.body[0].is_online,
              isOnlineUpdatedAt: res.body[0].is_online_update_time,
              isContinuousRecordingEnabled: res.body[0].is_cont_recording,
              firmwareUpdateStatus: res.body[0].firmware_update_status,
              isRegistered: res.body[0].is_registered,
              positionMetadata: res.body[0].position_metadata,
              privacyBackgroundImageUrl: res.body[0].privacy_background_image_url,
              privateIp: res.body[0].private_ip,
              publicIp: res.body[0].public_ip,
              videoStreamUrl: res.body[0].stream_url
            });
            resolve();
          } else {
            console.log('getSiteCamera failed');
            commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["l" /* GET_CAMERA_FAILURE */], { cameraId: cameraId });
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            });
          }
        } else {
          console.log('getSiteCamera failed');
          commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["l" /* GET_CAMERA_FAILURE */], { cameraId: cameraId });
          reject({
            status: res.status,
            statusText: res.statusText,
            body: res.body,
            successButText: 'incorrect api response'
          });
        }
        dispatch('checkOnlineStatusByApiResponse', res);
      }, function (err) {
        console.log(err);
        dispatch('checkOnlineStatusByApiResponse', err);
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["l" /* GET_CAMERA_FAILURE */], { cameraId: cameraId });
        reject({
          status: err.status,
          statusText: err.statusText,
          body: err.body
        });
      });
    });
  },
  getLiveSnapshot: function getLiveSnapshot(_ref4, cameraId) {
    var commit = _ref4.commit,
        getters = _ref4.getters,
        dispatch = _ref4.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["m" /* GET_CAMERA_LIVESNAPSHOT_REQUEST */], { cameraId: cameraId });
      __WEBPACK_IMPORTED_MODULE_4__api_device__["a" /* default */].getLiveSnapshot(getters.camera(cameraId).siteId, cameraId).then(function (res) {
        if (res.body instanceof Object) {
          if (__WEBPACK_IMPORTED_MODULE_3__services_functions__["a" /* default */].hasAllKeys(res.body, ['data', 'timestamp'])) {
            commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["n" /* GET_CAMERA_LIVESNAPSHOT_SUCCESS */], {
              cameraId: cameraId,
              liveSnapshot: {
                url: 'data:image/jpg;base64,' + res.body.data,
                timestamp: res.body.timestamp
              }
            });
            resolve();
          } else {
            console.log('getLiveSnapshot failed');
            commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["o" /* GET_CAMERA_LIVESNAPSHOT_FAILURE */], { cameraId: cameraId });
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            });
          }
        } else {
          console.log('getLiveSnapshot failed');
          commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["o" /* GET_CAMERA_LIVESNAPSHOT_FAILURE */], { cameraId: cameraId });
          reject({
            status: res.status,
            statusText: res.statusText,
            body: res.body,
            successButText: 'incorrect api response'
          });
        }
        dispatch('checkOnlineStatusByApiResponse', res);
      }, function (err) {
        console.log(err);
        dispatch('checkOnlineStatusByApiResponse', err);
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["o" /* GET_CAMERA_LIVESNAPSHOT_FAILURE */], { cameraId: cameraId });
        reject({
          status: err.status,
          statusText: err.statusText,
          body: err.body
        });
      });
    });
  }

  // mutations
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* GET_CAMERA_REQUEST */], function (state, data) {
  state.status.getCamera = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getCamera, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.cameraId, 'requested'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["k" /* GET_CAMERA_SUCCESS */], function (state, data) {
  state.status.getCamera = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getCamera, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.cameraId, 'successful'));
  state.cameras = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.cameras, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.cameraId, data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["l" /* GET_CAMERA_FAILURE */], function (state, data) {
  state.status.getCamera = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getCamera, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.cameraId, 'failed'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["m" /* GET_CAMERA_LIVESNAPSHOT_REQUEST */], function (state, data) {
  state.status.getLiveSnapshot = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getLiveSnapshot, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.cameraId, 'requested'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["n" /* GET_CAMERA_LIVESNAPSHOT_SUCCESS */], function (state, data) {
  state.status.getLiveSnapshot = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getLiveSnapshot, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.cameraId, 'successful'));
  state.liveSnapshot = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.liveSnapshot, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.cameraId, data.liveSnapshot));
  // state.liveSnapshot[data.cameraId] = data.liveSnapshot
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["o" /* GET_CAMERA_LIVESNAPSHOT_FAILURE */], function (state, data) {
  state.status.getLiveSnapshot = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getLiveSnapshot, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.cameraId, 'failed'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* GET_CAMERA_THUMBNAILVIDEOS_REQUEST */], function (state, data) {
  state.status.getThumbnailVideos = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getThumbnailVideos, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.cameraId, 'requested'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* GET_CAMERA_THUMBNAILVIDEOS_SUCCESS */], function (state, data) {
  state.status.getThumbnailVideos = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getThumbnailVideos, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.cameraId, 'successful'));
  state.cameras[data.cameraId] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.cameras[data.cameraId], { thumbnailVideos: data.thumbnailVideos });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* GET_CAMERA_THUMBNAILVIDEOS_FAILURE */], function (state, data) {
  state.status.getThumbnailVideos = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getThumbnailVideos, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.cameraId, 'failed'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* GET_CAMERA_THUMBNAILVIDEO_SUCCESS */], function (state, data) {
  state.status.getThumbnailVideo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getThumbnailVideo, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.thumbnailVideoId, 'successful'));
  state.thumbnailVideos = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.thumbnailVideos, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.thumbnailVideoId, data.thumbnailVideo));
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(6);




// initial state
var state = {
  contacts: {},
  status: {
    getUser: {}
  }

  // getters
};var getters = {
  contact: function contact(state) {
    return function (contactId) {
      return state.contacts[contactId];
    };
  }

  // mutations
};var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* GET_CONTACT_SUCCESS */], function (state, data) {
  state.contacts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.contacts, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.contactId, data));
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_functions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_device__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(6);




var _mutations;





// initial state
var state = {
  events: {},
  eventSnapshots: {},
  lastEventId: null,
  status: {
    getEvent: {}
  }

  // getters
};var getters = {
  events: function events(state) {
    return state.events;
  },
  event: function event(state) {
    return function (eventId) {
      return state.events[eventId];
    };
  },
  lastEventId: function lastEventId(state) {
    return state.lastEventId;
  },
  lastEvent: function lastEvent(state, getters) {
    return getters.event(state.lastEventId);
  }

  // actions
};var actions = {
  getSiteCameraEvent: function getSiteCameraEvent(_ref, _ref2) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        getters = _ref.getters;
    var cameraId = _ref2.cameraId,
        eventId = _ref2.eventId;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* GET_SITE_CAMERA_EVENT_REQUEST */], { eventId: eventId });
      __WEBPACK_IMPORTED_MODULE_4__api_device__["a" /* default */].getSiteCameraEvent(getters.camera(cameraId).siteId, cameraId, eventId).then(function (res) {
        if (res.body[0] instanceof Object) {
          if (__WEBPACK_IMPORTED_MODULE_3__services_functions__["a" /* default */].hasAllKeys(res.body[0], ['event_id', 'device_id', 'watch', 'type', 'timestamp', 'bounding_box', 'status'])) {
            commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* GET_SITE_CAMERA_EVENT_SUCCESS */], {
              eventId: eventId,
              event: {
                eventId: res.body[0].event_id,
                cameraId: res.body[0].device_id,
                watch: res.body[0].watch,
                type: res.body[0].type !== 'netloss' ? res.body[0].type : res.body[0].status ? 'online' : 'offline',
                timestamp: res.body[0].timestamp,
                boundingBox: res.body[0].bounding_box
              }
            });
            resolve();
            if (res.body[0].type === 'netloss') dispatch('getSiteCamera', cameraId);
          } else {
            console.log('getSiteCameraEvent failed');
            commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* GET_SITE_CAMERA_EVENT_FAILURE */], { eventId: eventId });
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            });
          }
        } else {
          console.log('getSiteCameraEvent failed');
          commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* GET_SITE_CAMERA_EVENT_FAILURE */], { eventId: eventId });
          reject({
            status: res.status,
            statusText: res.statusText,
            body: res.body,
            successButText: 'incorrect api response'
          });
        }
        dispatch('checkOnlineStatusByApiResponse', res);
      }, function (err) {
        console.log(err);
        dispatch('checkOnlineStatusByApiResponse', err);
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* GET_SITE_CAMERA_EVENT_FAILURE */], { eventId: eventId });
        reject({
          status: err.status,
          statusText: err.statusText,
          body: err.body
        });
      });
    });
  }

  // mutations
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* GET_SITE_CAMERA_EVENT_REQUEST */], function (state, data) {
  state.status.getEvent = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getEvent, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.eventId, 'requested'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* GET_SITE_CAMERA_EVENT_SUCCESS */], function (state, data) {
  state.status.getEvent = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getEvent, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.eventId, 'successful'));
  state.events = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.events, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.eventId, data.event));
  state.lastEventId = data.eventId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* GET_SITE_CAMERA_EVENT_FAILURE */], function (state, data) {
  state.status.getEvent = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getEvent, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.eventId, 'failed'));
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_functions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_user__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(6);




var _mutations;





// initial state
var state = {
  myProfile: {
    userId: null,
    mqttAccessToken: null,
    email: null,
    firstName: null,
    lastName: null,
    created: null,
    isEmailVerified: null,
    profilePictureUrl: null
  },
  status: {
    getMyProfile: null
  },
  getMyProfileStatus: null

  // getters
};var getters = {
  myName: function myName(state) {
    return state.myProfile.firstName ? state.myProfile.firstName + ' ' + state.myProfile.lastName : null;
  },
  isValidAccount: function isValidAccount(state) {
    return state.myProfile.isEmailVerified;
  },
  myMqttAccessToken: function myMqttAccessToken(state) {
    return state.myProfile.mqttAccessToken;
  }

  // actions
};var actions = {
  getMyProfile: function getMyProfile(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["E" /* GET_MYPROFILE_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__api_user__["a" /* default */].getMyProfile().then(function (res) {
        if (res.body[0] instanceof Object) {
          if (__WEBPACK_IMPORTED_MODULE_3__services_functions__["a" /* default */].hasAllKeys(res.body[0], ['user_id', 'access_token', 'email', 'created', 'is_verify'])) {
            commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["F" /* GET_MYPROFILE_SUCCESS */], {
              userId: res.body[0].user_id,
              mqttAccessToken: res.body[0].access_token,
              email: res.body[0].email,
              firstName: res.body[0].firstname,
              lastName: res.body[0].lastname,
              created: res.body[0].created,
              isEmailVerified: res.body[0].is_verify,
              profilePictureUrl: res.body[0].provider_picture
            });
            resolve();
          } else {
            commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["G" /* GET_MYPROFILE_FAILURE */]);
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            });
          }
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["G" /* GET_MYPROFILE_FAILURE */]);
          reject({
            status: res.status,
            statusText: res.statusText,
            body: res.body,
            successButText: 'incorrect api response'
          });
        }
        dispatch('checkOnlineStatusByApiResponse', res);
      }, function (err) {
        console.log(err);
        dispatch('checkOnlineStatusByApiResponse', err);
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["G" /* GET_MYPROFILE_FAILURE */]);
        reject({
          status: err.status,
          statusText: err.statusText,
          body: err.body
        });
      });
    });
  }

  // mutations
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["E" /* GET_MYPROFILE_REQUEST */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { getMyProfile: 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["F" /* GET_MYPROFILE_SUCCESS */], function (state, profile) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { getMyProfile: 'successful' });
  state.myProfile = profile;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutation_types__["G" /* GET_MYPROFILE_FAILURE */], function (state) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { getMyProfile: 'failed' });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_functions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_site__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_types__ = __webpack_require__(6);





var _mutations;





// initial state
var state = {
  sites: {},
  status: {
    getMySites: null,
    getSite: {},
    getSiteCameras: {},
    getSiteMembers: {},
    getSiteContacts: {}
  }

  // getters
};var getters = {
  statusGetMySites: function statusGetMySites(state) {
    return state.status.getMySites;
  },
  mySites: function mySites(state) {
    return state.sites;
  },
  mySitesCount: function mySitesCount(state) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(state.sites).length;
  },
  site: function site(state, getters) {
    return function (siteId) {
      return getters.mySites[siteId];
    };
  }

  // actions
};var actions = {
  getSiteMembers: function getSiteMembers(_ref, siteId) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["p" /* GET_SITE_MEMBERS_REQUEST */], { siteId: siteId });
      __WEBPACK_IMPORTED_MODULE_5__api_site__["a" /* default */].getSiteMembers(siteId).then(function (res) {
        if (res.body instanceof Array) {
          var members = [];
          res.body.map(function (member) {
            if (member instanceof Object) {
              if (__WEBPACK_IMPORTED_MODULE_4__services_functions__["a" /* default */].hasAllKeys(member, ['user_id', 'invitation_time', 'invitation_status', 'role', 'is_signedup', 'email', 'firstname', 'lastname', 'provider_picture'])) {
                members.push(member.user_id);
                commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["b" /* GET_MEMBER_SUCCESS */], {
                  userId: member.user_id,
                  memberSince: new Date(member.invitation_time).getTime(),
                  isMember: member.invitation_status === 2 ? 1 : 0,
                  isSignedUp: member.is_signedup,
                  role: member.role === 0 ? 'owner' : member.role === 1 ? 'admin' : member.role === 2 ? 'manager' : null,
                  email: member.email,
                  firstName: member.firstname,
                  lastName: member.lastname,
                  profilePictureUrl: member.provider_picture
                });
              } else {
                console.log('getSiteMembers failed');
              }
            }
          });
          commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["q" /* GET_SITE_MEMBERS_SUCCESS */], {
            siteId: siteId,
            members: members
          });
          resolve();
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["r" /* GET_SITE_MEMBERS_FAILURE */], { siteId: siteId });
          reject({
            status: res.status,
            statusText: res.statusText,
            body: res.body,
            successButText: 'incorrect api response'
          });
        }
        dispatch('checkOnlineStatusByApiResponse', res);
      }, function (err) {
        console.log(err);
        dispatch('checkOnlineStatusByApiResponse', err);
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["r" /* GET_SITE_MEMBERS_FAILURE */], { siteId: siteId });
        reject({
          status: err.status,
          statusText: err.statusText,
          body: err.body
        });
      });
    });
  },
  getSiteContacts: function getSiteContacts(_ref2, siteId) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["s" /* GET_SITE_CONTACTS_REQUEST */], { siteId: siteId });
      __WEBPACK_IMPORTED_MODULE_5__api_site__["a" /* default */].getSiteContacts(siteId).then(function (res) {
        if (res.body instanceof Array) {
          var contacts = [];
          res.body.map(function (contact) {
            if (contact instanceof Object) {
              if (__WEBPACK_IMPORTED_MODULE_4__services_functions__["a" /* default */].hasAllKeys(contact, ['contact_id', 'created', 'email', 'is_verification_contact', 'name', 'phone', 'site_id', 'title'])) {
                contacts.push(contact.contact_id);
                commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["a" /* GET_CONTACT_SUCCESS */], {
                  contactId: contact.contact_id,
                  created: contact.created,
                  email: contact.email,
                  isVerificationContact: contact.is_verification_contact,
                  name: contact.name,
                  phone: contact.phone,
                  site_id: contact.site_id,
                  title: contact.title
                });
              } else {
                console.log('getSiteContacts failed');
              }
            }
          });
          commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["t" /* GET_SITE_CONTACTS_SUCCESS */], {
            siteId: siteId,
            contacts: contacts
          });
          resolve();
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["u" /* GET_SITE_CONTACTS_FAILURE */], { siteId: siteId });
          reject({
            status: res.status,
            statusText: res.statusText,
            body: res.body,
            successButText: 'incorrect api response'
          });
        }
        dispatch('checkOnlineStatusByApiResponse', res);
      }, function (err) {
        console.log(err);
        dispatch('checkOnlineStatusByApiResponse', err);
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["u" /* GET_SITE_CONTACTS_FAILURE */], { siteId: siteId });
        reject({
          status: err.status,
          statusText: err.statusText,
          body: err.body
        });
      });
    });
  },
  getSiteCameras: function getSiteCameras(_ref3, siteId) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["v" /* GET_SITE_CAMERAS_REQUEST */], { siteId: siteId });
      __WEBPACK_IMPORTED_MODULE_5__api_site__["a" /* default */].getSiteCameras(siteId).then(function (res) {
        if (res.body instanceof Array) {
          var cameras = [];
          res.body.map(function (camera) {
            if (camera instanceof Object) {
              if (__WEBPACK_IMPORTED_MODULE_4__services_functions__["a" /* default */].hasAllKeys(camera, ['device_id', 'alarm_zone', 'trouble_zone', 'name', 'mac', 'type', 'channel', 'model', 'is_privacy', 'privacy_disabled_duration', 'privacy_disabled_timestamp', 'is_activated', 'is_online', 'is_online_update_time', 'is_cont_recording', 'firmware_update_status', 'is_registered', 'position_metadata', 'privacy_background_image_url', 'private_ip', 'public_ip', 'stream_url'])) {
                cameras.push(camera.device_id);
                commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["k" /* GET_CAMERA_SUCCESS */], {
                  siteId: siteId,
                  cameraId: camera.device_id,
                  alarmZone: camera.alarm_zone,
                  troubleZone: camera.trouble_zone,
                  name: camera.name,
                  mac: camera.mac,
                  type: camera.type,
                  channel: camera.channel,
                  model: camera.model,
                  isPrivacyEnabled: camera.is_privacy,
                  privacyDisabledDuration: camera.privacy_disabled_duration,
                  privacyDisabledTimestamp: camera.privacy_disabled_timestamp,
                  isActivated: camera.is_activated,
                  isOnline: camera.is_online,
                  isOnlineUpdatedAt: camera.is_online_update_time,
                  isContinuousRecordingEnabled: camera.is_cont_recording,
                  firmwareUpdateStatus: camera.firmware_update_status,
                  isRegistered: camera.is_registered,
                  positionMetadata: camera.position_metadata,
                  privacyBackgroundImageUrl: camera.privacy_background_image_url,
                  privateIp: camera.private_ip,
                  publicIp: camera.public_ip,
                  videoStreamUrl: camera.stream_url
                });
              } else {
                console.log('getSiteCameras failed');
              }
            }
          });
          commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["w" /* GET_SITE_CAMERAS_SUCCESS */], {
            siteId: siteId,
            cameras: cameras
          });
          resolve();
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["x" /* GET_SITE_CAMERAS_FAILURE */], { siteId: siteId });
          reject({
            status: res.status,
            statusText: res.statusText,
            body: res.body,
            successButText: 'incorrect api response'
          });
        }
        dispatch('checkOnlineStatusByApiResponse', res);
      }, function (err) {
        console.log(err);
        dispatch('checkOnlineStatusByApiResponse', err);
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["x" /* GET_SITE_CAMERAS_FAILURE */], { siteId: siteId });
        reject({
          status: err.status,
          statusText: err.statusText,
          body: err.body
        });
      });
    });
  },
  getMySites: function getMySites(_ref4) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["y" /* GET_MYSITES_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_5__api_site__["a" /* default */].getMySites().then(function (res) {
        if (res.body instanceof Array) {
          res.body.map(function (site) {
            if (site instanceof Object) {
              if (__WEBPACK_IMPORTED_MODULE_4__services_functions__["a" /* default */].hasAllKeys(site, ['site_id', 'dealer_id', 'customer_account_number', 'name', 'blueprint_url', 'address1', 'address2', 'lat', 'lng', 'timezone', 'owner_email', 'owner_firstname', 'owner_lastname', 'user_id'])) {
                commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["z" /* GET_SITE_SUCCESS */], {
                  siteId: site.site_id,
                  dealerId: site.dealer_id,
                  customerAccountNumber: site.customer_account_number,
                  name: site.name,
                  blueprintUrl: site.blueprint_url,
                  address: site.address2 ? site.address2 + ' ' + site.address1 : site.address1,
                  address1: site.address1,
                  address2: site.address2,
                  lat: site.lat,
                  lng: site.lng,
                  timezone: site.timezone,
                  timezoneOffset: __WEBPACK_IMPORTED_MODULE_4__services_functions__["a" /* default */].getUtcOffset(site.timezone),
                  todayDateId: function todayDateId() {
                    return __WEBPACK_IMPORTED_MODULE_4__services_functions__["a" /* default */].getTodayBeginTimestamp(__WEBPACK_IMPORTED_MODULE_4__services_functions__["a" /* default */].getUtcOffset(site.timezone)) / 1000;
                  },
                  todayBeginTimestamp: function todayBeginTimestamp() {
                    return __WEBPACK_IMPORTED_MODULE_4__services_functions__["a" /* default */].getTodayBeginTimestamp(__WEBPACK_IMPORTED_MODULE_4__services_functions__["a" /* default */].getUtcOffset(site.timezone));
                  },
                  localTimeNow: function localTimeNow() {
                    return new Date(__WEBPACK_IMPORTED_MODULE_4__services_functions__["a" /* default */].getNowTimestamp(__WEBPACK_IMPORTED_MODULE_4__services_functions__["a" /* default */].getUtcOffset(site.timezone)));
                  },
                  convertToLocalTime: function convertToLocalTime(timestamp) {
                    return new Date(__WEBPACK_IMPORTED_MODULE_4__services_functions__["a" /* default */].getLocalTimestamp(timestamp, __WEBPACK_IMPORTED_MODULE_4__services_functions__["a" /* default */].getUtcOffset(site.timezone)));
                  },
                  primaryAdminEmail: site.owner_email,
                  primaryFirstName: site.owner_firstname,
                  primaryLastName: site.owner_lastname,
                  primaryAdminUserId: site.user_id
                });
              } else {
                console.log('getMySites failed');
              }
            }
          });
          commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["A" /* GET_MYSITES_SUCCESS */]);
          resolve();
        } else {
          commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["B" /* GET_MYSITES_FAILURE */]);
          reject({
            status: res.status,
            statusText: res.statusText,
            body: res.body,
            successButText: 'incorrect api response'
          });
        }
        dispatch('checkOnlineStatusByApiResponse', res);
      }, function (err) {
        console.log(err);
        dispatch('checkOnlineStatusByApiResponse', err);
        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["B" /* GET_MYSITES_FAILURE */]);
        reject({
          status: err.status,
          statusText: err.statusText,
          body: err.body
        });
      });
    });
  }

  // mutations
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["y" /* GET_MYSITES_REQUEST */], function (state, data) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { getMySites: 'requested' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["A" /* GET_MYSITES_SUCCESS */], function (state, data) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { getMySites: 'successful' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["B" /* GET_MYSITES_FAILURE */], function (state, data) {
  state.status = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status, { getMySites: 'failed' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["C" /* GET_SITE_REQUEST */], function (state, data) {
  state.status.getSite = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getSite, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.siteId, 'requested'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["z" /* GET_SITE_SUCCESS */], function (state, data) {
  state.status.getSite = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getSite, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.siteId, 'successful'));
  state.sites = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.sites, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.siteId, data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["D" /* GET_SITE_FAILURE */], function (state, data) {
  state.status.getSite = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getSite, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.siteId, 'failed'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["v" /* GET_SITE_CAMERAS_REQUEST */], function (state, data) {
  state.status.getSiteCameras = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getSiteCameras, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.siteId, 'requested'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["w" /* GET_SITE_CAMERAS_SUCCESS */], function (state, data) {
  state.status.getSiteCameras = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getSiteCameras, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.siteId, 'successful'));
  state.sites[data.siteId] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.sites[data.siteId], { cameras: data.cameras });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["x" /* GET_SITE_CAMERAS_FAILURE */], function (state, data) {
  state.status.getSiteCameras = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getSiteCameras, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.siteId, 'failed'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["p" /* GET_SITE_MEMBERS_REQUEST */], function (state, data) {
  state.status.getSiteMembers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getSiteMembers, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.siteId, 'requested'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["q" /* GET_SITE_MEMBERS_SUCCESS */], function (state, data) {
  state.status.getSiteMembers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getSiteMembers, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.siteId, 'successful'));
  state.sites[data.siteId] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.sites[data.siteId], { members: data.members });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["r" /* GET_SITE_MEMBERS_FAILURE */], function (state, data) {
  state.status.getSiteMembers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getSiteMembers, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.siteId, 'failed'));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["s" /* GET_SITE_CONTACTS_REQUEST */], function (state, data) {
  state.status.getSiteContacts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getSiteContacts, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.siteId, 'requested'));
  state.sites[data.siteId] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.sites[data.siteId], { contacts: data.contacts });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["t" /* GET_SITE_CONTACTS_SUCCESS */], function (state, data) {
  state.status.getSiteContacts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getSiteContacts, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.siteId, 'successful'));
  state.sites[data.siteId] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.sites[data.siteId], { contacts: data.contacts });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["u" /* GET_SITE_CONTACTS_FAILURE */], function (state, data) {
  state.status.getSiteContacts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.status.getSiteContacts, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.siteId, 'failed'));
  state.sites[data.siteId] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.sites[data.siteId], { contacts: data.contacts });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(6);




// initial state
var state = {
  users: {},
  status: {
    getUser: {}
  }

  // getters
};var getters = {
  user: function user(state) {
    return function (userId) {
      return state.users[userId];
    };
  }

  // mutations
};var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* GET_MEMBER_SUCCESS */], function (state, data) {
  state.users = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.users, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, data.userId, data));
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_functions__ = __webpack_require__(10);


var logger = function logger(store) {
  store.subscribe(function (mutation) {
    if (mutation.type !== 'ADD_LOG') {
      if (mutation.type.indexOf('SUCCESS') > -1) {
        if (mutation.type.indexOf('MYPROFILE') > -1 || mutation.type.indexOf('MYSITES') > -1 || mutation.type.indexOf('CAMERA_THUMBNAILVIDEOS') > -1) {
          store.commit('ADD_LOG', {
            status: 'success',
            message: __WEBPACK_IMPORTED_MODULE_0__services_functions__["a" /* default */].capitalizeFirstLetter((mutation.type + '').replace(/_/g, ' '))
          });
        } else if (mutation.type.indexOf('SITE_CAMERA_EVENT') > -1) {
          store.commit('ADD_LOG', {
            status: 'success',
            message: 'New event on ' + store.getters.camera(mutation.payload.event.cameraId).name
          });
        }
      } else if (mutation.type.indexOf('FAILURE') > -1) {
        if (mutation.type.indexOf('MYPROFILE') > -1 || mutation.type.indexOf('MYSITES') > -1) {
          store.commit('ADD_LOG', {
            status: 'error',
            message: __WEBPACK_IMPORTED_MODULE_0__services_functions__["a" /* default */].capitalizeFirstLetter((mutation.type + '').replace(/_/g, ' '))
          });
        }
      } else if (mutation.type.indexOf('MQTT') > -1) {
        if (mutation.type.indexOf('DISCONNECTED') > -1) {
          store.commit('ADD_LOG', {
            status: 'error',
            message: 'Disconnected from the CHeKT cloud'
          });
        } else if (mutation.type.indexOf('CONNECTED') > -1) {
          store.commit('ADD_LOG', {
            status: 'info',
            message: 'Connected to the CHeKT cloud'
          });
        } else if (mutation.type.indexOf('SITE_SUBSCRIBE') > -1) {
          store.commit('ADD_LOG', {
            status: 'info',
            message: 'Start listening to realtime event for ' + store.getters.site(mutation.payload).name
          });
        } else if (mutation.type.indexOf('SITE_UNSUBSCRIBE') > -1) {
          store.commit('ADD_LOG', {
            status: 'info',
            message: 'Stop listening to realtime event for ' + store.getters.site(mutation.payload).name
          });
        }
      } else if (mutation.type.indexOf('SELECT_SITE') > -1) {
        store.commit('ADD_LOG', {
          status: 'info',
          message: store.getters.site(mutation.payload).name + ' is selected'
        });
      } else if (mutation.type.indexOf('INTERNET') > -1) {
        if (mutation.type.indexOf('DISCONNECTED') > -1) {
          store.commit('ADD_LOG', {
            status: 'error',
            message: 'Internet disconnected'
          });
        } else if (mutation.type.indexOf('CONNECTED') > -1) {
          store.commit('ADD_LOG', {
            status: 'success',
            message: 'Internet connected'
          });
        }
      } else if (mutation.type.indexOf('API_RATELIMIT') > -1) {
        if (mutation.type.indexOf('LOCKED') > -1) {
          store.commit('ADD_LOG', {
            status: 'error',
            message: 'Too many request. Your api requests are blocked for 1 minute.'
          });
        } else if (mutation.type.indexOf('UNLOCKED') > -1) {
          store.commit('ADD_LOG', {
            status: 'success',
            message: 'Your api requests are now unblocked.'
          });
        }
      }
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (logger);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_paho_mqtt__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_paho_mqtt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_paho_mqtt__);



var Paho = window.Paho;

var mqtt = function mqtt(store) {
  store.subscribe(function (mutation) {
    if (mutation.type === 'GET_MYPROFILE_SUCCESS') {
      if (!store.getters.isMqttConnected) startConnectionInterval();
    } else if (mutation.type === 'SELECT_SITE') {
      if (store.getters.mqttCurrentSiteId) removeSiteEventSubscription(store.getters.mqttCurrentSiteId);
      addSiteEventSubscription(store.getters.currentSiteId);
    }
  });

  var client = null;
  var connectInterval$ = null;
  var connectionRetrySecond = 5;

  function startConnectionInterval() {
    if (!store.getters.isMqttConnected) {
      connect('app', store.getters.myMqttAccessToken, 'enduser-web-' + Math.floor(Math.random() * 1000000000));
    }
    stopConnectionInterval();
    connectInterval$ = setInterval(function () {
      if (!store.getters.isMqttConnected) {
        connect('app', store.getters.myMqttAccessToken, 'enduser-web-' + Math.floor(Math.random() * 1000000000));
      }
    }, connectionRetrySecond * 1000);
  }

  function stopConnectionInterval() {
    if (connectInterval$) {
      clearInterval(connectInterval$);
      connectInterval$ = null;
    }
  }

  function connect(userName, password, clientId) {
    client = new Paho.MQTT.Client(__WEBPACK_IMPORTED_MODULE_0__services_environment__["a" /* default */].mqttTargetPath, __WEBPACK_IMPORTED_MODULE_0__services_environment__["a" /* default */].mqttTargetPathPort, '', clientId);
    client.onConnectionLost = function (responseObject) {
      if (responseObject.errorCode !== 0) {
        store.commit('MQTT_DISCONNECTED');
      }
    };
    client.onMessageArrived = function (message) {
      var destination = message.destinationName;
      var payloadString = message.payloadString;
      var payloadBytes = message.payloadBytes;
      parseMessage(destination, payloadString, payloadBytes);
    };
    client.onFailure = function (err) {
      console.log(err);
    };
    client.connect({
      useSSL: true,
      userName: userName,
      password: password,
      onSuccess: function onSuccess() {
        store.commit('MQTT_CONNECTED');
        if (store.getters.currentSiteId) addSiteEventSubscription(store.getters.currentSiteId);
      }
    });
  }

  function addSiteEventSubscription(siteId) {
    if (store.getters.isMqttConnected) {
      client.subscribe('chekt/sites/' + siteId, { qos: 1 });
      setTimeout(function () {
        store.commit('MQTT_SITE_SUBSCRIBE', siteId);
      }, 1000);
    }
  }

  function removeSiteEventSubscription(siteId) {
    if (store.getters.isMqttConnected) {
      client.unsubscribe('chekt/sites/' + siteId, {});
      store.commit('MQTT_SITE_UNSUBSCRIBE', siteId);
    }
  }

  function onNewEvent(deviceId, eventId) {
    // get event for only cameras (not non-camera device)
    if (store.getters.camera(deviceId)) {
      store.dispatch('getSiteCameraEvent', {
        cameraId: deviceId,
        eventId: eventId
      });
    }
  }

  function onPrivacyChange(deviceId, isEnabled) {
    console.log('deviceId: ' + deviceId);
    console.log('isEnabled: ' + isEnabled);
  }

  function parseMessage(destination, payloadString, payloadBytes) {
    var body = void 0;
    try {
      body = JSON.parse(payloadString);
    } catch (e) {
      console.log(e);
    }

    var destinationObj = destination.split('/');
    if (destinationObj[0] === 'chekt') {
      if (destinationObj[1] === 'sites') {
        if (body) {
          if (body['type']) {
            if (body['type'] === 'notification') {
              if (body['subject'] === 'event') {
                if (body['payload']) {
                  if (body['payload']['event_id'] && body['payload']['device_id']) {
                    onNewEvent(body['payload']['device_id'], body['payload']['event_id']);
                    // console.log(body)
                  } else {
                    console.log('Wrong mqtt message payload!');
                    console.log(body);
                  }
                } else {
                  console.log('Mqtt message payload not found!');
                  console.log(body);
                }
              } else if (body['subject'] === 'privacy') {
                if (body['payload']) {
                  if (body['payload']['device_id'] && body['payload']['enable'] !== null && body['payload']['enable'] !== undefined) {
                    onPrivacyChange(body['payload']['device_id'], body['payload']['enable']);
                    // console.log(body)
                  } else {
                    console.log('Wrong mqtt message payload!');
                    console.log(body);
                  }
                } else {
                  console.log('Mqtt message payload not found!');
                  console.log(body);
                }
              } else {
                console.log('Not supported mqtt message subject!');
                console.log(body);
              }
            } else {
              console.log('Not supported mqtt message type!');
              console.log(body);
            }
          } else {
            console.log('Wrong mqtt body!');
            console.log(body);
          }
        } else {
          console.log('Wrong mqtt payload!');
          console.log(payloadString);
        }
      } else {
        console.log('Not supported mqtt destination!');
        console.log(destination);
      }
    } else {
      console.log('Not supported mqtt destination!');
      console.log(destination);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (mqtt);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_user__ = __webpack_require__(36);


var pingCloud = function pingCloud(store) {
  var pingCloud$i = null;
  var pingCloudIntervalWhenOnline = 1000 * 10;
  var pingCloudIntervalWhenOffline = 1000 * 5;

  store.subscribe(function (mutation) {
    if (mutation.type === 'INTERNET_DISCONNECTED') {
      startPingCloud();
    } else if (mutation.type === 'INTERNET_CONNECTED') {
      stopPingCloud();
    }
  });

  function pingCloudWhenOnline() {
    setInterval(function () {
      pingCloud();
    }, pingCloudIntervalWhenOnline);
  }
  function startPingCloud() {
    stopPingCloud();
    pingCloud$i = setInterval(function () {
      pingCloud();
    }, pingCloudIntervalWhenOffline);
  }
  function stopPingCloud() {
    if (pingCloud$i) {
      clearInterval(pingCloud$i);
      pingCloud$i = null;
    }
  }

  function pingCloud() {
    __WEBPACK_IMPORTED_MODULE_0__api_user__["a" /* default */].pingCloud().then(function (res) {
      store.dispatch('checkOnlineStatusByApiResponse', res);
    }, function (err) {
      store.dispatch('checkOnlineStatusByApiResponse', err);
    });
  }

  pingCloudWhenOnline();
};

/* harmony default export */ __webpack_exports__["a"] = (pingCloud);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(6);




var _mutations;




// initial state
var state = {
  dataParams: {
    historyRetentionDay: 30,
    maxEventSnapshots: 200,
    maxEvents: 1000
  },
  selectionParams: {
    selectedSiteId: null,
    selectedDateId: null,
    selectedCameraId: null,
    selectedEventId: null,
    selectedVideoId: null,
    selectedThumbnailVideoId: null,
    selectedMemberId: null,
    selectedContactId: null
  },
  pageParams: {
    isMenuActive: false
  },
  mqttStatus: {
    isMqttConnected: false,
    currentSiteId: null
  },
  isOnline: true,
  isApiRateLimitLocked: false,
  logs: [],
  lastLog: {}

  // actions
};var actions = {
  initializeData: function initializeData(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch,
        state = _ref.state;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      dispatch('getMyProfile').then(function () {
        dispatch('getMySites').then(function () {
          var siteIds = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.sites.sites);
          // if there are available sites for user
          if (siteIds.length > 0) {
            var siteIdToBeSelected = null;
            var currentEmail = state.myProfile.myProfile.email;
            if (__WEBPACK_IMPORTED_MODULE_3__services_environment__["a" /* default */].getLastEmail() === currentEmail) {
              if (__WEBPACK_IMPORTED_MODULE_3__services_environment__["a" /* default */].getLastSiteId()) {
                if (state.sites.sites[__WEBPACK_IMPORTED_MODULE_3__services_environment__["a" /* default */].getLastSiteId()]) {
                  siteIdToBeSelected = __WEBPACK_IMPORTED_MODULE_3__services_environment__["a" /* default */].getLastSiteId();
                }
              }
            } else __WEBPACK_IMPORTED_MODULE_3__services_environment__["a" /* default */].setLastEmail(currentEmail);
            if (!siteIdToBeSelected) siteIdToBeSelected = siteIds[0];
            dispatch('selectSite', siteIdToBeSelected);
            resolve(siteIdToBeSelected);
          } else {
            reject('There is no site available');
          }
        });
      });
    });
  },
  selectSite: function selectSite(_ref2, siteId) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    __WEBPACK_IMPORTED_MODULE_3__services_environment__["a" /* default */].setLastSiteId(siteId);
    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["H" /* SELECT_SITE */], siteId);
    dispatch('getSiteCameras', siteId);
    dispatch('getSiteMembers', siteId);
    dispatch('getSiteContacts', siteId);
  },
  selectCamera: function selectCamera(_ref3, cameraId) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["I" /* SELECT_CAMERA */], cameraId);
  },
  checkOnlineStatusByApiResponse: function checkOnlineStatusByApiResponse(_ref4, res) {
    var commit = _ref4.commit,
        state = _ref4.state,
        dispatch = _ref4.dispatch;

    if (res.status === 0) {
      if (state.isOnline) commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["J" /* INTERNET_DISCONNECTED */]);
    } else if (res.status === 429) {
      if (!state.isApiRateLimitLocked) commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["K" /* API_RATELIMIT_LOCKED */]);
    } else if (res.status !== 401 && res.status !== 404) {
      if (!state.isOnline) {
        commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["L" /* INTERNET_CONNECTED */]);
        dispatch('initializeData');
      }
      if (state.isApiRateLimitLocked) commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["M" /* API_RATELIMIT_UNLOCKED */]);
    }
  }

  // getters
};var getters = {
  isOnline: function isOnline(state) {
    return state.isOnline;
  },
  isApiRateLimitLocked: function isApiRateLimitLocked(state) {
    return state.isApiRateLimitLocked;
  },
  lastLog: function lastLog(state) {
    return state.lastLog;
  },
  logs: function logs(state) {
    return state.logs;
  },
  currentSiteId: function currentSiteId(state) {
    return state.selectionParams.selectedSiteId;
  },
  currentSite: function currentSite(state, getters) {
    return state.sites.sites[getters.currentSiteId];
  },
  currentCameraId: function currentCameraId(state) {
    return state.selectionParams.selectedCameraId;
  },
  currentCamera: function currentCamera(state, getters) {
    return state.cameras.cameras[getters.currentCameraId];
  },
  currentCameraLiveSnapshot: function currentCameraLiveSnapshot(state, getters) {
    return state.cameras.liveSnapshot[getters.currentCameraId];
  },
  currentCameraStatusGetLiveSnapshot: function currentCameraStatusGetLiveSnapshot(state, getters) {
    return state.cameras.status.getLiveSnapshot[getters.currentCameraId];
  },
  historyRetentionDay: function historyRetentionDay(state) {
    return state.dataParams.historyRetentionDay;
  },
  isMenuActive: function isMenuActive(state) {
    return state.pageParams.isMenuActive;
  },
  isMqttConnected: function isMqttConnected(state) {
    return state.mqttStatus.isMqttConnected;
  },
  mqttCurrentSiteId: function mqttCurrentSiteId(state) {
    return state.mqttStatus.currentSiteId;
  }

  // mutations
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["H" /* SELECT_SITE */], function (state, siteId) {
  state.selectionParams.selectedSiteId = siteId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["N" /* SELECT_DATE */], function (state, dateId) {
  state.selectionParams.selectedDateId = dateId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["I" /* SELECT_CAMERA */], function (state, cameraId) {
  state.selectionParams.selectedCameraId = cameraId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["O" /* SELECT_EVENT */], function (state, eventId) {
  state.selectionParams.selectedEventId = eventId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["P" /* SELECT_VIDEO */], function (state, videoId) {
  state.selectionParams.selectedVideoId = videoId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["Q" /* SELECT_THUMBNAILVIDEO */], function (state, thumbnailVideoId) {
  state.selectionParams.selectedThumbnailVideoId = thumbnailVideoId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["R" /* SELECT_MEMBER */], function (state, memberId) {
  state.selectionParams.selectedMemberId = memberId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["S" /* SELECT_CONTACT */], function (state, contactId) {
  state.selectionParams.selectedContactId = contactId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["T" /* OPEN_MENU */], function (state) {
  state.pageParams.isMenuActive = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["U" /* CLOSE_MENU */], function (state) {
  state.pageParams.isMenuActive = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["V" /* ADD_LOG */], function (state, log) {
  state.lastLog = {
    status: log.status, // success, info, warning, error
    message: log.message,
    timestamp: +new Date().getTime()
  };
  if (state.logs.length > 9) state.logs.shift();
  state.logs.push(state.lastLog);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["W" /* MQTT_CONNECTED */], function (state) {
  state.mqttStatus.isMqttConnected = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["X" /* MQTT_DISCONNECTED */], function (state) {
  state.mqttStatus.isMqttConnected = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["Y" /* MQTT_SITE_SUBSCRIBE */], function (state, siteId) {
  state.mqttStatus.currentSiteId = siteId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["Z" /* MQTT_SITE_UNSUBSCRIBE */], function (state, siteId) {
  // siteId is not used,, because here currently only listening one site at a time
  state.mqttStatus.currentSiteId = null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["L" /* INTERNET_CONNECTED */], function (state) {
  state.isOnline = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["J" /* INTERNET_DISCONNECTED */], function (state) {
  state.isOnline = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["K" /* API_RATELIMIT_LOCKED */], function (state) {
  state.isApiRateLimitLocked = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["M" /* API_RATELIMIT_UNLOCKED */], function (state) {
  state.isApiRateLimitLocked = false;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  created: function created() {
    var _this = this;

    // for dev environment
    if (this.$route.query.id_token) {
      this.onIdTokenInQuery();
    }
    if (this.$auth.authenticated()) {
      this.initializeData().then(function (siteId) {
        _this.$router.push({ name: 'cameras', params: { siteId: siteId } });
      }, function (errMessage) {
        console.log(errMessage);
      });
    }
  },
  data: function data() {
    return {
      dummyEvent: null
    };
  },

  methods: {
    initializeData: function initializeData() {
      return this.$store.dispatch('initializeData');
    },
    onIdTokenInQuery: function onIdTokenInQuery() {
      this.$auth.storeIdTokenToLocalStorage(this.$route.query.id_token);
      this.$router.push(this.$route.name);
    },
    preventPinchZoom: function preventPinchZoom(event) {
      if (event.scale !== 1) {
        event.preventDefault();
      }
    }
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HScrollComp__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HScrollComp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__HScrollComp__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'camera',
  components: { HScrollComp: __WEBPACK_IMPORTED_MODULE_0__HScrollComp___default.a },
  created: function created() {
    this.initializeMockupData();
    // let cameraId = this.$route.params.cameraId
    // console.log('cameraId: ' + cameraId)
    this.$store.commit('CLOSE_MENU');
    this.$store.dispatch('getThumbnailVideos', { cameraId: this.currentCameraId });
    // temporary solution (Below)
    if (!this.currentCameraId) this.onClickClose();
    this.startRefreshingCameraLiveSnapshot();
  },
  mounted: function mounted() {
    this.$forceUpdate();
  },
  beforeDestroy: function beforeDestroy() {
    this.pauseThumbnailVideo();
    this.stopRefreshingCameraLiveSnapshot();
  },
  data: function data() {
    return {
      refreshingCameraLiveSnapshot$1: null,
      tabs: ['playback', 'live'],
      selectedTabIndex: 1,
      isFullSceenActive: false,
      refreshHScrollCompCount: 0,
      dates: [],
      hours: [],
      minutes: [],
      recordingVideoUrls: [],
      thumbnailVideoUrls: [],
      selectedDateIndex: null,
      selectedHourIndex: null,
      selectedMinuteIndex: null,
      oneHourInThumbnailVideo: 1 / 30 * 60, // 1min / 30fps * 60mins
      oneMinuteInThumbnailVideo: 1 / 30, // 1min / 30fps
      syncingThumbnailVideoCurrentTimeWithTimeline$i: null,
      syncingRecordingVideoCurrentTimeWithTimeline$i: null,
      isRecordingVideoPaused: true,
      isRecordingVideoLoaded: false,
      isThumbnailVideoPaused: true,
      isThumbnailVideoLoaded: false,
      recordingVideoPlaybackRates: [1],
      recordingVideoDefaultPlaybackRateIndex: 0,
      thumbnailVideoPlaybackRates: [0.1, 0.5, 1],
      thumbnailVideoDefaultPlaybackRateIndex: 0,
      isRecordingVideoActive: true
    };
  },

  computed: {
    isMenuActive: function isMenuActive() {
      return this.$store.getters.isMenuActive;
    },
    currentSiteId: function currentSiteId() {
      return this.$store.getters.currentSiteId;
    },
    currentSite: function currentSite() {
      return this.$store.getters.currentSite;
    },
    currentCameraId: function currentCameraId() {
      return this.$store.getters.currentCameraId;
    },
    currentCamera: function currentCamera() {
      return this.$store.getters.currentCamera;
    },
    currentCameraLiveSnapshot: function currentCameraLiveSnapshot() {
      return this.$store.getters.currentCameraLiveSnapshot;
    },
    currentCameraStatusGetLiveSnapshot: function currentCameraStatusGetLiveSnapshot() {
      return this.$store.getters.currentCameraStatusGetLiveSnapshot;
    },
    camera: function camera() {
      return this.$store.getters.camera;
    },
    thumbnailVideo: function thumbnailVideo() {
      return this.$store.getters.thumbnailVideo;
    },
    statusGetLiveSnapshot: function statusGetLiveSnapshot() {
      return this.$store.getters.statusGetLiveSnapshot;
    },
    liveSnapshot: function liveSnapshot() {
      return this.$store.getters.liveSnapshot;
    }
  },
  methods: {
    onClickClose: function onClickClose() {
      // this.$router.push({ name: 'cameras', params: { siteId: 123 }})
      this.$router.push({ name: 'cameras' });
    },
    startRefreshingCameraLiveSnapshot: function startRefreshingCameraLiveSnapshot() {
      var _this = this;

      var refreshInterval = 1000 * 0.2; // 1 sec
      this.stopRefreshingCameraLiveSnapshot();
      this.refreshingCameraLiveSnapshot$i = setInterval(function () {
        _this.getCameraLiveSnapshot();
      }, refreshInterval);
    },
    stopRefreshingCameraLiveSnapshot: function stopRefreshingCameraLiveSnapshot() {
      if (this.refreshingCameraLiveSnapshot$i) {
        clearInterval(this.refreshingCameraLiveSnapshot$i);
        this.refreshingCameraLiveSnapshot$i = null;
      }
    },
    getCameraLiveSnapshot: function getCameraLiveSnapshot() {
      if (this.currentCamera) {
        if (this.currentCamera.isOnline && this.currentCameraStatusGetLiveSnapshot !== 'requested') {
          this.$store.dispatch('getLiveSnapshot', this.currentCameraId);
        }
      }
    },
    toggleTab: function toggleTab() {
      if (this.isRecordingVideoActive && this.isThumbnailVideoPaused) {
        var targetTabIndex = this.selectedTabIndex + 1;
        if (targetTabIndex === this.tabs.length) targetTabIndex = 0;
        this.selectTab(targetTabIndex);
      }
    },
    selectTab: function selectTab(index) {
      if (this.tabs[index]) {
        this.selectedTabIndex = index;
      }
    },
    initializeTheWayRecordingVideoShow: function initializeTheWayRecordingVideoShow(src) {
      if (this.$refs.recordingVideo) {
        if (src) {
          this.$refs.recordingVideo.src = src;
          this.$refs.recordingVideo.controls = false;
          this.setRecordingVideoDefaultPlaybackRate();
          this.isRecordingVideoLoaded = false;
          this.$refs.recordingVideo.onloadedmetadata = function () {
            this.onLoadedRecordingVideoMetadata();
          }.bind(this);
          this.$refs.recordingVideo.onpause = function () {
            this.pauseRecordingVideo();
          }.bind(this);
          this.$refs.recordingVideo.load();
        } else {
          this.$refs.recordingVideo.src = '';
        }
      }
    },
    initializeTheWayThumbnailVideoShow: function initializeTheWayThumbnailVideoShow(src) {
      if (this.$refs.thumbnailVideo) {
        if (src) {
          this.$refs.thumbnailVideo.src = src;
          this.$refs.thumbnailVideo.controls = false;
          this.setThumbnailVideoDefaultPlaybackRate();
          this.isThumbnailVideoLoaded = false;
          this.$refs.thumbnailVideo.onloadedmetadata = function () {
            this.onLoadedThumbnailVideoMetadata();
          }.bind(this);
          this.$refs.thumbnailVideo.onpause = function () {
            this.pauseThumbnailVideo();
          }.bind(this);
          this.$refs.thumbnailVideo.load();
        } else {
          this.$refs.thumbnailVideo.src = '';
        }
      }
    },
    setRecordingVideoDefaultPlaybackRate: function setRecordingVideoDefaultPlaybackRate(rate) {
      if (this.$refs.recordingVideo) {
        this.$refs.recordingVideo.defaultPlaybackRate = this.recordingVideoPlaybackRates[this.recordingVideoDefaultPlaybackRateIndex];
        this.$refs.recordingVideo.playbackRate = this.recordingVideoPlaybackRates[this.recordingVideoDefaultPlaybackRateIndex];
      }
    },
    setThumbnailVideoDefaultPlaybackRate: function setThumbnailVideoDefaultPlaybackRate(rate) {
      if (this.$refs.thumbnailVideo) {
        this.$refs.thumbnailVideo.defaultPlaybackRate = this.thumbnailVideoPlaybackRates[this.thumbnailVideoDefaultPlaybackRateIndex];
        this.$refs.thumbnailVideo.playbackRate = this.thumbnailVideoPlaybackRates[this.thumbnailVideoDefaultPlaybackRateIndex];
      }
    },
    onLoadedRecordingVideoMetadata: function onLoadedRecordingVideoMetadata() {
      var _this2 = this;

      this.isRecordingVideoLoaded = true;
      if (this.selectedHourIndex !== null && this.selectedMinuteIndex !== null) {
        var videoCurrentTime = this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo;
        this.updateVideoCurrentTime(videoCurrentTime);
        setTimeout(function () {
          _this2.resetTimeIndexes();
        }, 300);
      }
      if (this.isRecordingVideoPaused) {
        this.pauseRecordingVideo();
      } else {
        this.playRecordingVideo();
      }
    },
    onLoadedThumbnailVideoMetadata: function onLoadedThumbnailVideoMetadata() {
      var _this3 = this;

      this.isThumbnailVideoLoaded = true;
      if (this.selectedHourIndex !== null && this.selectedMinuteIndex !== null) {
        var videoCurrentTime = this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo;
        this.updateVideoCurrentTime(videoCurrentTime);
        setTimeout(function () {
          _this3.resetTimeIndexes();
        }, 300);
      }
      if (this.isThumbnailVideoPaused) {
        this.pauseThumbnailVideo();
      } else {
        this.playThumbnailVideo();
      }
    },
    getAmPm: function getAmPm(hourIndex) {
      if (hourIndex < 12) return 'am';else return 'pm';
    },
    initializeMockupData: function initializeMockupData() {
      var _this4 = this;

      this.dates = [];
      this.thumbnailVideoUrls = [];
      var todayDateId = this.currentSite.todayDateId();
      for (var i = 0; i < 32; i++) {
        this.dates.push(todayDateId - i * (60 * 60 * 24));
        this.thumbnailVideoUrls.push(null);
      }
      this.hours = [];
      for (var _i = 0; _i < 24; _i++) {
        this.hours.push(_i === 0 ? '12' : _i < 12 ? _i : _i === 12 ? '12' : _i - 12);
      }
      this.minutes = [];
      for (var _i2 = 0; _i2 < 60; _i2++) {
        this.minutes.push(_i2 < 10 ? '0' + _i2 : _i2 + '');
      }
      this.recordingVideoUrls = ['https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-0.mp4', 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-1.mp4', 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-2.mp4'];
      this.thumbnailVideoUrls[this.dates.length - 1] = 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-0.mp4';
      this.thumbnailVideoUrls[this.dates.length - 2] = 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-1.mp4';
      this.thumbnailVideoUrls[this.dates.length - 3] = 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-2.mp4';

      this.$nextTick(function () {
        _this4.selectDate(0);
        _this4.selectHour(8);
        _this4.selectMinute(30);
      });
    },
    onClickDate: function onClickDate(dateIndex) {
      this.selectDate(dateIndex);
    },
    selectDate: function selectDate(dateIndex) {
      if (this.selectedDateIndex !== dateIndex) {
        if (this.currentCamera.thumbnailVideos) {
          if (this.thumbnailVideo(this.currentCamera.thumbnailVideos[this.dates[dateIndex]])) {
            if (this.thumbnailVideo(this.currentCamera.thumbnailVideos[this.dates[dateIndex]]).isThumbnailVideoCreated) {
              this.initializeTheWayThumbnailVideoShow(this.thumbnailVideo(this.currentCamera.thumbnailVideos[this.dates[dateIndex]]).url);
              this.initializeTheWayRecordingVideoShow(this.thumbnailVideo(this.currentCamera.thumbnailVideos[this.dates[dateIndex]]).url);
              this.selectedDateIndex = dateIndex;
            }
          } else {
            this.pauseThumbnailVideo();
            this.selectedDateIndex = dateIndex;
          }
        }
      } else {
        this.refreshHScrollCompo();
      }
    },
    goToBeforeMinute: function goToBeforeMinute() {
      if (this.selectedMinuteIndex === 0) {
        // Go to before hour
        if (this.selectedHourIndex > 0) {
          this.onClickHour(this.selectedHourIndex - 1);
          this.onClickMinute(this.minutes.length - 1);
        }
      } else {
        // Go to before minute
        this.onClickMinute(this.selectedMinuteIndex - 1);
      }
    },
    goToNextMinute: function goToNextMinute() {
      if (this.minutes.length - 1 === this.selectedMinuteIndex) {
        // Go to next hour
        if (this.selectedHourIndex < this.hours.length - 1) {
          this.onClickHour(this.selectedHourIndex + 1);
          this.onClickMinute(0);
        }
      } else {
        // Go to next minute
        this.onClickMinute(this.selectedMinuteIndex + 1);
      }
    },
    onClickHour: function onClickHour(hourIndex) {
      var _this5 = this;

      if (this.selectedHourIndex !== hourIndex) {
        this.selectHour(hourIndex);
        var videoCurrentTime = hourIndex * this.oneHourInThumbnailVideo + this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo;
        this.updateVideoCurrentTime(videoCurrentTime);
        setTimeout(function () {
          _this5.resetTimeIndexes();
        }, 300);
      } else {
        this.refreshHScrollCompo();
      }
    },
    selectHour: function selectHour(hourIndex) {
      this.selectedHourIndex = hourIndex;
    },
    onClickMinute: function onClickMinute(timeIndex) {
      var _this6 = this;

      if (this.selectedMinuteIndex !== timeIndex) {
        this.selectMinute(timeIndex);
        var videoCurrentTime = timeIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo;
        this.updateVideoCurrentTime(videoCurrentTime);
        setTimeout(function () {
          _this6.resetTimeIndexes();
        }, 300);
      } else {
        this.refreshHScrollCompo();
      }
    },
    selectMinute: function selectMinute(timeIndex) {
      this.selectedMinuteIndex = timeIndex;
    },
    updateVideoCurrentTime: function updateVideoCurrentTime(time) {
      if (this.$refs.thumbnailVideo) {
        this.$refs.thumbnailVideo.currentTime = time + 0.001;
      }
    },
    refreshHScrollCompo: function refreshHScrollCompo() {
      this.refreshHScrollCompCount++;
    },
    onClickFastRewind: function onClickFastRewind() {
      // is Recording video paused?
      if (this.isThumbnailVideoPaused) {
        this.goToBeforeMinute();
      } else {
        if (this.isRecordingVideoActive) {
          this.isRecordingVideoActive = false;
          this.setThumbnailVideoDefaultPlaybackRate();
        } else {
          var index = this.thumbnailVideoDefaultPlaybackRateIndex - 1;
          if (index < 0) index = 0;
          this.thumbnailVideoDefaultPlaybackRateIndex = index;
          this.setThumbnailVideoDefaultPlaybackRate();
        }
      }
    },
    onClickFastForward: function onClickFastForward() {
      // is Recording video paused?
      if (this.isThumbnailVideoPaused) {
        this.goToNextMinute();
      } else {
        if (this.isRecordingVideoActive) {
          this.isRecordingVideoActive = false;
          this.setThumbnailVideoDefaultPlaybackRate();
        } else {
          var index = this.thumbnailVideoDefaultPlaybackRateIndex + 1;
          if (index >= this.thumbnailVideoPlaybackRates.length) index = index - 1;
          this.thumbnailVideoDefaultPlaybackRateIndex = index;
          this.setThumbnailVideoDefaultPlaybackRate();
        }
      }
    },
    resetPlaybackConfigurations: function resetPlaybackConfigurations() {
      this.isRecordingVideoActive = true;
      this.recordingVideoDefaultPlaybackRateIndex = 0;
      this.thumbnailVideoDefaultPlaybackRateIndex = 0;
      this.setThumbnailVideoDefaultPlaybackRate();
    },
    onClickActionBtnForRecordingVideo: function onClickActionBtnForRecordingVideo() {
      if (this.$refs.recordingVideo) {
        if (this.$refs.recordingVideo.paused) this.playRecordingVideo();else this.pauseRecordingVideo();
      }
    },
    onClickPlayAndPause: function onClickPlayAndPause() {
      if (this.$refs.thumbnailVideo) {
        if (this.$refs.thumbnailVideo.paused) this.playThumbnailVideo();else this.pauseThumbnailVideo();
        this.resetPlaybackConfigurations();
      }
    },
    playRecordingVideo: function playRecordingVideo() {
      if (this.$refs.recordingVideo && this.isRecordingVideoLoaded) {
        this.isRecordingVideoPaused = false;
        this.$refs.recordingVideo.play();
        this.startSyncingRecordingVideoCurrentTimeWithTimeline();
      }
    },
    pauseRecordingVideo: function pauseRecordingVideo() {
      if (this.$refs.recordingVideo) {
        this.isRecordingVideoPaused = true;
        this.$refs.recordingVideo.pause();
        this.stopSyncingRecordingVideoCurrentTimeWithTimeline();
      }
    },
    playThumbnailVideo: function playThumbnailVideo() {
      if (this.$refs.thumbnailVideo && this.isThumbnailVideoLoaded) {
        this.isThumbnailVideoPaused = false;
        this.$refs.thumbnailVideo.play();
        this.startSyncingThumbnailVideoCurrentTimeWithTimeline();
      }
    },
    pauseThumbnailVideo: function pauseThumbnailVideo() {
      if (this.$refs.thumbnailVideo) {
        this.isThumbnailVideoPaused = true;
        this.$refs.thumbnailVideo.pause();
        this.stopSyncingThumbnailVideoCurrentTimeWithTimeline();
      }
    },
    startSyncingRecordingVideoCurrentTimeWithTimeline: function startSyncingRecordingVideoCurrentTimeWithTimeline() {
      var _this7 = this;

      this.stopSyncingRecordingVideoCurrentTimeWithTimeline();
      this.syncingRecordingVideoCurrentTimeWithTimeline$i = setInterval(function () {
        _this7.resetTimeIndexes();
      }, 300);
    },
    stopSyncingRecordingVideoCurrentTimeWithTimeline: function stopSyncingRecordingVideoCurrentTimeWithTimeline() {
      if (this.syncingThumbnailVideoCurrentTimeWithTimeline$i) {
        clearInterval(this.syncingRecordingVideoCurrentTimeWithTimeline$i);
        this.resetTimeIndexes();
      }
    },
    startSyncingThumbnailVideoCurrentTimeWithTimeline: function startSyncingThumbnailVideoCurrentTimeWithTimeline() {
      var _this8 = this;

      this.stopSyncingThumbnailVideoCurrentTimeWithTimeline();
      this.syncingThumbnailVideoCurrentTimeWithTimeline$i = setInterval(function () {
        _this8.resetTimeIndexes();
      }, 300);
    },
    stopSyncingThumbnailVideoCurrentTimeWithTimeline: function stopSyncingThumbnailVideoCurrentTimeWithTimeline() {
      if (this.syncingThumbnailVideoCurrentTimeWithTimeline$i) {
        clearInterval(this.syncingThumbnailVideoCurrentTimeWithTimeline$i);
        this.resetTimeIndexes();
      }
    },
    resetTimeIndexes: function resetTimeIndexes() {
      if (this.$refs.thumbnailVideo) {
        var time = this.$refs.thumbnailVideo.currentTime;
        var minuteIndex = Math.floor(time / this.oneMinuteInThumbnailVideo);
        var hourIndex = Math.floor(time / this.oneHourInThumbnailVideo);
        minuteIndex = minuteIndex % this.minutes.length;
        hourIndex = hourIndex % this.hours.length;
        this.selectMinute(minuteIndex);
        this.selectHour(hourIndex);
      }
    },
    onClickRecordingVideoPlaybackRate: function onClickRecordingVideoPlaybackRate() {
      var index = this.recordingVideoDefaultPlaybackRateIndex + 1;
      if (index >= this.recordingVideoPlaybackRates.length) index = 0;
      this.recordingVideoDefaultPlaybackRateIndex = index;
      this.setRecordingVideoDefaultPlaybackRate();
    },
    onClickThumbnailVideoPlaybackRate: function onClickThumbnailVideoPlaybackRate() {
      var index = this.thumbnailVideoDefaultPlaybackRateIndex + 1;
      if (index >= this.thumbnailVideoPlaybackRates.length) index = 0;
      this.thumbnailVideoDefaultPlaybackRateIndex = index;
      this.setThumbnailVideoDefaultPlaybackRate();
    },
    enableFullSceen: function enableFullSceen() {
      this.isFullSceenActive = true;
    },
    disableFullSceen: function disableFullSceen() {
      this.isFullSceenActive = false;
    }
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HScrollComp__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HScrollComp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__HScrollComp__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'camera-comp',
  components: { HScrollComp: __WEBPACK_IMPORTED_MODULE_0__HScrollComp___default.a },
  created: function created() {
    this.initializeMockupData();
  },
  beforeDestroy: function beforeDestroy() {
    this.pauseThumbnailVideo();
  },
  props: {
    cameraObj: Object
  },
  data: function data() {
    return {
      tabs: ['playback', 'live'],
      selectedTabIndex: 1,
      isFullSceenActive: false,
      refreshHScrollCompCount: 0,
      dates: [],
      hours: [],
      minutes: [],
      recordingVideoUrls: [],
      thumbnailVideoUrls: [],
      selectedDateIndex: null,
      selectedHourIndex: null,
      selectedMinuteIndex: null,
      oneHourInThumbnailVideo: 1 / 30 * 60, // 1min / 30fps * 60mins
      oneMinuteInThumbnailVideo: 1 / 30, // 1min / 30fps
      syncingThumbnailVideoCurrentTimeWithTimeline$i: null,
      syncingRecordingVideoCurrentTimeWithTimeline$i: null,
      isRecordingVideoPaused: true,
      isRecordingVideoLoaded: false,
      isThumbnailVideoPaused: true,
      isThumbnailVideoLoaded: false,
      recordingVideoPlaybackRates: [1],
      recordingVideoDefaultPlaybackRateIndex: 0,
      thumbnailVideoPlaybackRates: [0.1, 0.5, 1],
      thumbnailVideoDefaultPlaybackRateIndex: 0,
      isRecordingVideoActive: true
    };
  },

  methods: {
    close: function close() {
      this.$emit('onClose', null);
    },
    toggleTab: function toggleTab() {
      if (this.isRecordingVideoActive && this.isThumbnailVideoPaused) {
        var targetTabIndex = this.selectedTabIndex + 1;
        if (targetTabIndex === this.tabs.length) targetTabIndex = 0;
        this.selectTab(targetTabIndex);
      }
    },
    selectTab: function selectTab(index) {
      if (this.tabs[index]) {
        this.selectedTabIndex = index;
      }
    },
    initializeTheWayRecordingVideoShow: function initializeTheWayRecordingVideoShow(src) {
      if (this.$refs.recordingVideo) {
        if (src) {
          this.$refs.recordingVideo.src = src;
          this.$refs.recordingVideo.controls = false;
          this.setRecordingVideoDefaultPlaybackRate();
          this.isRecordingVideoLoaded = false;
          this.$refs.recordingVideo.onloadedmetadata = function () {
            this.onLoadedRecordingVideoMetadata();
          }.bind(this);
          this.$refs.recordingVideo.onpause = function () {
            this.pauseRecordingVideo();
          }.bind(this);
          this.$refs.recordingVideo.load();
        } else {
          this.$refs.recordingVideo.src = '';
        }
      }
    },
    initializeTheWayThumbnailVideoShow: function initializeTheWayThumbnailVideoShow(src) {
      if (this.$refs.thumbnailVideo) {
        if (src) {
          this.$refs.thumbnailVideo.src = src;
          this.$refs.thumbnailVideo.controls = false;
          this.setThumbnailVideoDefaultPlaybackRate();
          this.isThumbnailVideoLoaded = false;
          this.$refs.thumbnailVideo.onloadedmetadata = function () {
            this.onLoadedThumbnailVideoMetadata();
          }.bind(this);
          this.$refs.thumbnailVideo.onpause = function () {
            this.pauseThumbnailVideo();
          }.bind(this);
          this.$refs.thumbnailVideo.load();
        } else {
          this.$refs.thumbnailVideo.src = '';
        }
      }
    },
    setRecordingVideoDefaultPlaybackRate: function setRecordingVideoDefaultPlaybackRate(rate) {
      if (this.$refs.recordingVideo) {
        this.$refs.recordingVideo.defaultPlaybackRate = this.recordingVideoPlaybackRates[this.recordingVideoDefaultPlaybackRateIndex];
        this.$refs.recordingVideo.playbackRate = this.recordingVideoPlaybackRates[this.recordingVideoDefaultPlaybackRateIndex];
      }
    },
    setThumbnailVideoDefaultPlaybackRate: function setThumbnailVideoDefaultPlaybackRate(rate) {
      if (this.$refs.thumbnailVideo) {
        this.$refs.thumbnailVideo.defaultPlaybackRate = this.thumbnailVideoPlaybackRates[this.thumbnailVideoDefaultPlaybackRateIndex];
        this.$refs.thumbnailVideo.playbackRate = this.thumbnailVideoPlaybackRates[this.thumbnailVideoDefaultPlaybackRateIndex];
      }
    },
    onLoadedRecordingVideoMetadata: function onLoadedRecordingVideoMetadata() {
      var _this = this;

      this.isRecordingVideoLoaded = true;
      if (this.selectedHourIndex !== null && this.selectedMinuteIndex !== null) {
        var videoCurrentTime = this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo;
        this.updateVideoCurrentTime(videoCurrentTime);
        setTimeout(function () {
          _this.resetTimeIndexes();
        }, 300);
      }
      if (this.isRecordingVideoPaused) {
        this.pauseRecordingVideo();
      } else {
        this.playRecordingVideo();
      }
    },
    onLoadedThumbnailVideoMetadata: function onLoadedThumbnailVideoMetadata() {
      var _this2 = this;

      this.isThumbnailVideoLoaded = true;
      if (this.selectedHourIndex !== null && this.selectedMinuteIndex !== null) {
        var videoCurrentTime = this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo;
        this.updateVideoCurrentTime(videoCurrentTime);
        setTimeout(function () {
          _this2.resetTimeIndexes();
        }, 300);
      }
      if (this.isThumbnailVideoPaused) {
        this.pauseThumbnailVideo();
      } else {
        this.playThumbnailVideo();
      }
    },
    getAmPm: function getAmPm(hourIndex) {
      if (hourIndex < 12) return 'am';else return 'pm';
    },
    initializeMockupData: function initializeMockupData() {
      var _this3 = this;

      this.dates = [];
      this.thumbnailVideoUrls = [];
      for (var i = 1; i < 32; i++) {
        this.dates.push('May ' + i);
        this.thumbnailVideoUrls.push(null);
      }
      this.hours = [];
      for (var _i = 0; _i < 24; _i++) {
        this.hours.push(_i === 0 ? '12' : _i < 12 ? _i : _i === 12 ? '12' : _i - 12);
      }
      this.minutes = [];
      for (var _i2 = 0; _i2 < 60; _i2++) {
        this.minutes.push(_i2 < 10 ? '0' + _i2 : _i2 + '');
      }
      this.recordingVideoUrls = ['https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-0.mp4', 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-1.mp4', 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-2.mp4'];
      this.thumbnailVideoUrls[this.dates.length - 1] = 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-0.mp4';
      this.thumbnailVideoUrls[this.dates.length - 2] = 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-1.mp4';
      this.thumbnailVideoUrls[this.dates.length - 3] = 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-2.mp4';
      this.$nextTick(function () {
        _this3.selectDate(_this3.dates.length - 2);
        _this3.selectHour(8);
        _this3.selectMinute(30);
      });
    },
    onClickDate: function onClickDate(dateIndex) {
      this.selectDate(dateIndex);
    },
    selectDate: function selectDate(dateIndex) {
      if (this.selectedDateIndex !== dateIndex) {
        if (this.thumbnailVideoUrls[dateIndex]) {
          this.initializeTheWayThumbnailVideoShow(this.thumbnailVideoUrls[dateIndex]);
          this.initializeTheWayRecordingVideoShow(this.recordingVideoUrls[dateIndex]);
          this.selectedDateIndex = dateIndex;
        } else {
          this.pauseThumbnailVideo();
          this.selectedDateIndex = dateIndex;
        }
      } else {
        this.refreshHScrollCompo();
      }
    },
    goToBeforeMinute: function goToBeforeMinute() {
      if (this.selectedMinuteIndex === 0) {
        // Go to before hour
        if (this.selectedHourIndex > 0) {
          this.onClickHour(this.selectedHourIndex - 1);
          this.onClickMinute(this.minutes.length - 1);
        }
      } else {
        // Go to before minute
        this.onClickMinute(this.selectedMinuteIndex - 1);
      }
    },
    goToNextMinute: function goToNextMinute() {
      if (this.minutes.length - 1 === this.selectedMinuteIndex) {
        // Go to next hour
        if (this.selectedHourIndex < this.hours.length - 1) {
          this.onClickHour(this.selectedHourIndex + 1);
          this.onClickMinute(0);
        }
      } else {
        // Go to next minute
        this.onClickMinute(this.selectedMinuteIndex + 1);
      }
    },
    onClickHour: function onClickHour(hourIndex) {
      var _this4 = this;

      if (this.selectedHourIndex !== hourIndex) {
        this.selectHour(hourIndex);
        var videoCurrentTime = hourIndex * this.oneHourInThumbnailVideo + this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo;
        this.updateVideoCurrentTime(videoCurrentTime);
        setTimeout(function () {
          _this4.resetTimeIndexes();
        }, 300);
      } else {
        this.refreshHScrollCompo();
      }
    },
    selectHour: function selectHour(hourIndex) {
      this.selectedHourIndex = hourIndex;
    },
    onClickMinute: function onClickMinute(timeIndex) {
      var _this5 = this;

      if (this.selectedMinuteIndex !== timeIndex) {
        this.selectMinute(timeIndex);
        var videoCurrentTime = timeIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo;
        this.updateVideoCurrentTime(videoCurrentTime);
        setTimeout(function () {
          _this5.resetTimeIndexes();
        }, 300);
      } else {
        this.refreshHScrollCompo();
      }
    },
    selectMinute: function selectMinute(timeIndex) {
      this.selectedMinuteIndex = timeIndex;
    },
    updateVideoCurrentTime: function updateVideoCurrentTime(time) {
      if (this.$refs.thumbnailVideo) {
        this.$refs.thumbnailVideo.currentTime = time + 0.001;
      }
    },
    refreshHScrollCompo: function refreshHScrollCompo() {
      this.refreshHScrollCompCount++;
    },
    onClickFastRewind: function onClickFastRewind() {
      // is Recording video paused?
      if (this.isThumbnailVideoPaused) {
        this.goToBeforeMinute();
      } else {
        if (this.isRecordingVideoActive) {
          this.isRecordingVideoActive = false;
          this.setThumbnailVideoDefaultPlaybackRate();
        } else {
          var index = this.thumbnailVideoDefaultPlaybackRateIndex - 1;
          if (index < 0) index = 0;
          this.thumbnailVideoDefaultPlaybackRateIndex = index;
          this.setThumbnailVideoDefaultPlaybackRate();
        }
      }
    },
    onClickFastForward: function onClickFastForward() {
      // is Recording video paused?
      if (this.isThumbnailVideoPaused) {
        this.goToNextMinute();
      } else {
        if (this.isRecordingVideoActive) {
          this.isRecordingVideoActive = false;
          this.setThumbnailVideoDefaultPlaybackRate();
        } else {
          var index = this.thumbnailVideoDefaultPlaybackRateIndex + 1;
          if (index >= this.thumbnailVideoPlaybackRates.length) index = index - 1;
          this.thumbnailVideoDefaultPlaybackRateIndex = index;
          this.setThumbnailVideoDefaultPlaybackRate();
        }
      }
    },
    resetPlaybackConfigurations: function resetPlaybackConfigurations() {
      this.isRecordingVideoActive = true;
      this.recordingVideoDefaultPlaybackRateIndex = 0;
      this.thumbnailVideoDefaultPlaybackRateIndex = 0;
      this.setThumbnailVideoDefaultPlaybackRate();
    },
    onClickActionBtnForRecordingVideo: function onClickActionBtnForRecordingVideo() {
      if (this.$refs.recordingVideo) {
        if (this.$refs.recordingVideo.paused) this.playRecordingVideo();else this.pauseRecordingVideo();
      }
    },
    onClickPlayAndPause: function onClickPlayAndPause() {
      if (this.$refs.thumbnailVideo) {
        if (this.$refs.thumbnailVideo.paused) this.playThumbnailVideo();else this.pauseThumbnailVideo();
        this.resetPlaybackConfigurations();
      }
    },
    playRecordingVideo: function playRecordingVideo() {
      if (this.$refs.recordingVideo && this.isRecordingVideoLoaded) {
        this.isRecordingVideoPaused = false;
        this.$refs.recordingVideo.play();
        this.startSyncingRecordingVideoCurrentTimeWithTimeline();
      }
    },
    pauseRecordingVideo: function pauseRecordingVideo() {
      if (this.$refs.recordingVideo) {
        this.isRecordingVideoPaused = true;
        this.$refs.recordingVideo.pause();
        this.stopSyncingRecordingVideoCurrentTimeWithTimeline();
      }
    },
    playThumbnailVideo: function playThumbnailVideo() {
      if (this.$refs.thumbnailVideo && this.isThumbnailVideoLoaded) {
        this.isThumbnailVideoPaused = false;
        this.$refs.thumbnailVideo.play();
        this.startSyncingThumbnailVideoCurrentTimeWithTimeline();
      }
    },
    pauseThumbnailVideo: function pauseThumbnailVideo() {
      if (this.$refs.thumbnailVideo) {
        this.isThumbnailVideoPaused = true;
        this.$refs.thumbnailVideo.pause();
        this.stopSyncingThumbnailVideoCurrentTimeWithTimeline();
      }
    },
    startSyncingRecordingVideoCurrentTimeWithTimeline: function startSyncingRecordingVideoCurrentTimeWithTimeline() {
      var _this6 = this;

      this.stopSyncingRecordingVideoCurrentTimeWithTimeline();
      this.syncingRecordingVideoCurrentTimeWithTimeline$i = setInterval(function () {
        _this6.resetTimeIndexes();
      }, 300);
    },
    stopSyncingRecordingVideoCurrentTimeWithTimeline: function stopSyncingRecordingVideoCurrentTimeWithTimeline() {
      if (this.syncingThumbnailVideoCurrentTimeWithTimeline$i) {
        clearInterval(this.syncingRecordingVideoCurrentTimeWithTimeline$i);
        this.resetTimeIndexes();
      }
    },
    startSyncingThumbnailVideoCurrentTimeWithTimeline: function startSyncingThumbnailVideoCurrentTimeWithTimeline() {
      var _this7 = this;

      this.stopSyncingThumbnailVideoCurrentTimeWithTimeline();
      this.syncingThumbnailVideoCurrentTimeWithTimeline$i = setInterval(function () {
        _this7.resetTimeIndexes();
      }, 300);
    },
    stopSyncingThumbnailVideoCurrentTimeWithTimeline: function stopSyncingThumbnailVideoCurrentTimeWithTimeline() {
      if (this.syncingThumbnailVideoCurrentTimeWithTimeline$i) {
        clearInterval(this.syncingThumbnailVideoCurrentTimeWithTimeline$i);
        this.resetTimeIndexes();
      }
    },
    resetTimeIndexes: function resetTimeIndexes() {
      if (this.$refs.thumbnailVideo) {
        var time = this.$refs.thumbnailVideo.currentTime;
        var minuteIndex = Math.floor(time / this.oneMinuteInThumbnailVideo);
        var hourIndex = Math.floor(time / this.oneHourInThumbnailVideo);
        minuteIndex = minuteIndex % this.minutes.length;
        hourIndex = hourIndex % this.hours.length;
        this.selectMinute(minuteIndex);
        this.selectHour(hourIndex);
      }
    },
    onClickRecordingVideoPlaybackRate: function onClickRecordingVideoPlaybackRate() {
      var index = this.recordingVideoDefaultPlaybackRateIndex + 1;
      if (index >= this.recordingVideoPlaybackRates.length) index = 0;
      this.recordingVideoDefaultPlaybackRateIndex = index;
      this.setRecordingVideoDefaultPlaybackRate();
    },
    onClickThumbnailVideoPlaybackRate: function onClickThumbnailVideoPlaybackRate() {
      var index = this.thumbnailVideoDefaultPlaybackRateIndex + 1;
      if (index >= this.thumbnailVideoPlaybackRates.length) index = 0;
      this.thumbnailVideoDefaultPlaybackRateIndex = index;
      this.setThumbnailVideoDefaultPlaybackRate();
    },
    enableFullSceen: function enableFullSceen() {
      this.isFullSceenActive = true;
    },
    disableFullSceen: function disableFullSceen() {
      this.isFullSceenActive = false;
    }
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_environment__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_device__ = __webpack_require__(24);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cameras',
  created: function created() {
    this.startRefreshingSiteLiveSnapshots();
    this.initializeConfigurations();
  },
  destroyed: function destroyed() {
    this.stopRefreshingSiteLiveSnapshots();
  },
  data: function data() {
    return {
      cameraIdsWithEvents: {},
      refreshingSiteLiveSnapshot$i: null,
      snapshotMaxWidthSizes: [200, 300, 400, 500, 600, 700, 800],
      snapshotMaxWidthIndexInUse: null
    };
  },
  computed: {
    nowTimestamp: function nowTimestamp() {
      return new Date().getTime();
    },
    isMenuActive: function isMenuActive() {
      return this.$store.getters.isMenuActive;
    },
    currentSiteId: function currentSiteId() {
      return this.$store.getters.currentSiteId;
    },
    currentSite: function currentSite() {
      return this.$store.getters.currentSite;
    },
    lastEventId: function lastEventId() {
      return this.$store.getters.lastEventId;
    },
    lastEvent: function lastEvent() {
      return this.$store.getters.lastEvent;
    },
    event: function event() {
      return this.$store.getters.event;
    },
    camera: function camera() {
      return this.$store.getters.camera;
    },
    statusGetLiveSnapshot: function statusGetLiveSnapshot() {
      return this.$store.getters.statusGetLiveSnapshot;
    },
    liveSnapshot: function liveSnapshot() {
      return this.$store.getters.liveSnapshot;
    }
  },
  watch: {
    lastEventId: function lastEventId(now, before) {
      this.onNewEvent(now);
    }
  },
  methods: {
    test: function test() {
      // device.updateFactoryMac()
      console.log(__WEBPACK_IMPORTED_MODULE_1__api_device__["a" /* default */]);
    },
    onNewEvent: function onNewEvent(eventId) {
      this.cameraIdsWithEvents[this.event(eventId).cameraId] = true;
    },
    initializeConfigurations: function initializeConfigurations() {
      if (__WEBPACK_IMPORTED_MODULE_0__services_environment__["a" /* default */].getCamerasLastZoomIndex() !== null) this.snapshotMaxWidthIndexInUse = __WEBPACK_IMPORTED_MODULE_0__services_environment__["a" /* default */].getCamerasLastZoomIndex();else this.snapshotMaxWidthIndexInUse = this.snapshotMaxWidthSizes.length - 1;
    },
    onClickZoomIn: function onClickZoomIn() {
      if (this.snapshotMaxWidthSizes.length - 1 > this.snapshotMaxWidthIndexInUse) {
        this.snapshotMaxWidthIndexInUse++;
        __WEBPACK_IMPORTED_MODULE_0__services_environment__["a" /* default */].setCamerasLastZoomIndex(this.snapshotMaxWidthIndexInUse);
      }
    },
    onClickZoomOut: function onClickZoomOut() {
      if (this.snapshotMaxWidthIndexInUse > 0) {
        this.snapshotMaxWidthIndexInUse--;
        __WEBPACK_IMPORTED_MODULE_0__services_environment__["a" /* default */].setCamerasLastZoomIndex(this.snapshotMaxWidthIndexInUse);
      }
    },
    onClickCamera: function onClickCamera(cameraId) {
      this.selectCamera(cameraId);
      this.$router.push({ name: 'camera', params: { cameraId: cameraId } });
    },
    selectCamera: function selectCamera(cameraId) {
      this.$store.dispatch('selectCamera', cameraId);
    },
    onClickMenu: function onClickMenu() {
      if (this.isMenuActive) this.$store.commit('CLOSE_MENU');else this.$store.commit('OPEN_MENU');
    },
    startRefreshingSiteLiveSnapshots: function startRefreshingSiteLiveSnapshots() {
      var _this = this;

      var refreshInterval = 1000 * 5; // 5 sec
      this.stopRefreshingSiteLiveSnapshots();
      setTimeout(function () {
        _this.getSiteLiveSnapshots();
      }, 1000);
      this.refreshingSiteLiveSnapshot$i = setInterval(function () {
        _this.getSiteLiveSnapshots();
      }, refreshInterval);
    },
    stopRefreshingSiteLiveSnapshots: function stopRefreshingSiteLiveSnapshots() {
      if (this.refreshingSiteLiveSnapshot$i) {
        clearInterval(this.refreshingSiteLiveSnapshot$i);
        this.refreshingSiteLiveSnapshot$i = null;
      }
    },
    getSiteLiveSnapshots: function getSiteLiveSnapshots() {
      var _this2 = this;

      if (this.currentSite) {
        if (this.currentSite.cameras) {
          this.currentSite.cameras.map(function (cameraId) {
            if (_this2.camera(cameraId).isOnline && _this2.statusGetLiveSnapshot(cameraId) !== 'requested') {
              _this2.$store.dispatch('getLiveSnapshot', cameraId);
            }
          });
        }
      }
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'comp-menu',
  computed: {
    mySites: function mySites() {
      return this.$store.getters.mySites;
    }
  },
  methods: {
    selectSite: function selectSite(siteId) {
      this.$store.dispatch('selectSite', siteId);
      this.$store.commit('CLOSE_MENU');
      this.$router.push({ name: 'cameras', params: { siteId: siteId } });
    }
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'comp-toaster',
  data: function data() {
    return {
      toasterItems: {},
      successTimeout: 1000 * 3,
      infoTimeout: 1000 * 3,
      warningTimeout: 1000 * 20,
      errorTimeout: 1000 * 60 * 5
    };
  },
  computed: {
    lastLog: function lastLog() {
      return this.$store.getters.lastLog;
    }
  },
  watch: {
    lastLog: function lastLog(now, before) {
      this.onNewLogAdded();
    }
  },
  methods: {
    onNewLogAdded: function onNewLogAdded() {
      var _this = this;

      var key = this.lastLog.timestamp;
      if (this.toasterItems[key] === undefined) {
        this.$set(this.toasterItems, key, {
          status: this.lastLog.status,
          message: this.lastLog.message,
          timestamp: this.lastLog.timestamp
        });
        var timeout = this.lastLog.status === 'success' ? this.successTimeout : this.lastLog.status === 'info' ? this.infoTimeout : this.lastLog.status === 'warning' ? this.warningTimeout : this.lastLog.status === 'error' ? this.errorTimeout : null;
        setTimeout(function () {
          _this.hideToaster(key);
        }, timeout);
      }
    },
    onClickToaster: function onClickToaster(key) {
      this.hideToaster(key);
    },
    hideToaster: function hideToaster(key) {
      this.$delete(this.toasterItems, key);
    }
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'h-scroll-comp',
  data: function data() {
    return {
      xPosition: 0,
      lastTouchX: null
    };
  },

  props: {
    active: Boolean,
    itemWidth: Number,
    selectedItem: Number,
    totalItems: Number,
    refreshTrigger: Number
  },
  watch: {
    selectedItem: function selectedItem(_selectedItem) {
      this.moveToItem(_selectedItem);
    },
    refreshTrigger: function refreshTrigger(_refreshTrigger) {
      this.moveToItem(this.selectedItem);
    }
  },
  methods: {
    onClose: function onClose() {
      this.$emit('onClose', null);
    },
    moveToItem: function moveToItem(itemNumber) {
      var newXPosition = -itemNumber * this.itemWidth;
      this.xPosition = newXPosition;
    },
    convertScrollToVertical: function convertScrollToVertical(event) {
      var newXPosition = this.xPosition + event.wheelDeltaY;
      if (newXPosition >= 0) newXPosition = 0;else if (newXPosition <= -this.itemWidth * (this.totalItems - 1)) newXPosition = -this.itemWidth * (this.totalItems - 1);
      this.xPosition = newXPosition;
    },
    onTouchStart: function onTouchStart(event) {
      this.lastTouchX = event.touches[0].pageX;
    },
    onTouchMove: function onTouchMove(event) {
      // !!!! Need to be changed below if condition
      if (!this.active) {
        var currentX = event.touches[0].pageX;
        var deltaX = currentX - this.lastTouchX;

        var newXPosition = this.xPosition + deltaX;
        if (newXPosition >= 0) newXPosition = 0;else if (newXPosition <= -this.itemWidth * (this.totalItems - 1)) newXPosition = -this.itemWidth * (this.totalItems - 1);
        this.xPosition = newXPosition;

        this.lastTouchX = currentX;

        event.returnValue = false;
        if (event.preventDefault) {
          event.preventDefault();
        }
      }
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PlaybackTimePickerComp__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PlaybackTimePickerComp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PlaybackTimePickerComp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CameraComp__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CameraComp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CameraComp__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: { PlaybackTimePickerComp: __WEBPACK_IMPORTED_MODULE_1__PlaybackTimePickerComp___default.a, CameraComp: __WEBPACK_IMPORTED_MODULE_2__CameraComp___default.a },
  created: function created() {
    this.initializeMockupData();
  },
  destoryed: function destoryed() {
    this.stopRefreshingSiteLiveSnapshots();
  },
  data: function data() {
    return {
      refreshingSiteLiveSnapshot$i: null,
      selectedBridge: null,
      isMenuActive: false,
      isPlaybackTimePickerClosed: true,
      isCameraComponentClosed: true,
      playingTime: null,
      playingDate: null,
      selectedCamera: null,
      bridges: {},
      channels: {}
    };
  },

  computed: {
    currentTime: function currentTime() {
      return new Date();
    },
    myName: function myName() {
      return this.$store.getters.myName;
    },
    mySites: function mySites() {
      return this.$store.getters.mySites;
    },
    currentSiteId: function currentSiteId() {
      return this.$store.getters.currentSiteId;
    },
    currentSite: function currentSite() {
      return this.$store.getters.currentSite;
    },
    camera: function camera() {
      return this.$store.getters.camera;
    },
    statusGetLiveSnapshot: function statusGetLiveSnapshot() {
      return this.$store.getters.statusGetLiveSnapshot;
    },
    liveSnapshot: function liveSnapshot() {
      return this.$store.getters.liveSnapshot;
    },
    historyRetentionDay: function historyRetentionDay() {
      return this.$store.getters.historyRetentionDay;
    },
    statusGetMySites: function statusGetMySites() {
      return this.$store.getters.statusGetMySites;
    },
    mySitesCount: function mySitesCount() {
      return this.$store.getters.mySitesCount;
    }
  },
  methods: {
    selectSite: function selectSite(siteId) {
      this.$store.dispatch('selectSite', siteId);
      this.startRefreshingSiteLiveSnapshots(siteId);
    },
    startRefreshingSiteLiveSnapshots: function startRefreshingSiteLiveSnapshots(siteId) {
      var _this = this;

      var refreshInterval = 1000 * 5; // 5 sec
      this.stopRefreshingSiteLiveSnapshots();
      setTimeout(function () {
        _this.getSiteLiveSnapshots(siteId);
      }, 1000);
      this.refreshingSiteLiveSnapshot$i = setInterval(function () {
        _this.getSiteLiveSnapshots(siteId);
        // re-render whole page only every 5 seconds (it doesn't work in iphone safari)
        _this.$forceUpdate();
      }, refreshInterval);
    },
    stopRefreshingSiteLiveSnapshots: function stopRefreshingSiteLiveSnapshots() {
      if (this.refreshingSiteLiveSnapshot$i) {
        clearInterval(this.refreshingSiteLiveSnapshot$i);
        this.refreshingSiteLiveSnapshot$i = null;
      }
    },
    getSiteLiveSnapshots: function getSiteLiveSnapshots(siteId) {
      var _this2 = this;

      if (this.currentSite.cameras) {
        this.currentSite.cameras.map(function (cameraId) {
          if (_this2.camera(cameraId).isOnline && _this2.statusGetLiveSnapshot(cameraId) !== 'requested') {
            _this2.$store.dispatch('getLiveSnapshot', cameraId);
          }
        });
      }
    },
    getAmPm: function getAmPm(hourIndex) {
      if (hourIndex < 12) return 'AM';else return 'PM';
    },
    initializeMockupData: function initializeMockupData() {
      this.playingTime = '11:32:42AM';
      this.playingDate = 'May 31';
      this.bridges = {
        '5805590F3848': {
          name: 'Bridge warehouse #1',
          mac: '5805590F3848',
          isOnline: 1,
          isCheckingConnection: 0,
          isAuthenticated: 1,
          isAuthenticating: 0,
          authError: 0,
          authUsername: null,
          authPassword: null,
          username: 'chekt',
          password: 'chekt'
        },
        '2314442034A3': {
          name: 'Bridge warehouse #2',
          mac: '2314442034A3',
          isOnline: 1,
          isCheckingConnection: 0,
          isAuthenticated: 1,
          isAuthenticating: 0,
          authError: 0,
          authUsername: null,
          authPassword: null,
          username: 'chekt',
          password: 'chekt'
        },
        '7D28A840579B': {
          name: 'Bridge #1',
          mac: '7D28A840579B',
          isOnline: 0,
          isCheckingConnection: 0,
          isAuthenticated: 0,
          isAuthenticating: 0,
          authError: 0,
          authUsername: null,
          authPassword: null,
          username: 'chekt',
          password: 'chekt'
        },
        '9C4DB1400906': {
          name: 'Bridge #2',
          mac: '9C4DB1400906',
          isOnline: 1,
          isCheckingConnection: 0,
          isAuthenticated: 1,
          isAuthenticating: 0,
          authError: 0,
          authUsername: null,
          authPassword: null,
          username: 'chekt',
          password: 'chekt'
        }
      };
      this.selectedBridge = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.bridges)[0];
      this.channels = {
        1: {
          name: 'Front Door',
          mac: '31E3FCC13DCC',
          liveSnapshotUrl: 'static/download-1.jpg',
          isOnline: 1
        },
        2: {
          name: 'Backyard West',
          mac: '9113DAF4D260',
          liveSnapshotUrl: 'static/download-2.jpg',
          isOnline: 1
        },
        3: {
          name: 'Backyard East',
          mac: '76C66A969C87',
          isOnline: 0
        },
        4: {
          name: 'Pool Entrance',
          mac: '88E3950DCEA6',
          liveSnapshotUrl: 'static/download-3.jpg',
          isOnline: 1
        },
        5: {
          name: 'Pool West',
          mac: 'F160A8B88346',
          liveSnapshotUrl: 'static/download-4.jpg',
          isOnline: 1
        },
        6: {
          name: 'Warehouse entrance',
          mac: '7F6757119781',
          liveSnapshotUrl: 'static/download-5.jpg',
          isOnline: 1
        },
        7: {
          name: 'Warehouse East',
          mac: '449ED2C5290C',
          liveSnapshotUrl: 'static/download-6.jpg',
          isOnline: 1
        },
        8: {
          name: 'Second Warehouse',
          mac: '8933BC6118F8',
          isOnline: 0
        }
      };
      this.thumbnailVideoUrls = ['https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-0.mp4', 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-1.mp4', 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-2.mp4'];
    },
    checkBridgeConnection: function checkBridgeConnection(mac) {
      var _this3 = this;

      if (!this.bridges[mac].isCheckingConnection) {
        this.bridges[mac].isCheckingConnection = 1;
        setTimeout(function () {
          _this3.bridges[mac].isCheckingConnection = 0;
          _this3.bridges[mac].isOnline = 1;
        }, 1000);
      }
    },
    authenticateBridgeConnection: function authenticateBridgeConnection(mac) {
      var _this4 = this;

      if (this.bridges[mac].authUsername && this.bridges[mac].authPassword) {
        this.bridges[mac].authError = 0;
        this.bridges[mac].isAuthenticating = 1;
        setTimeout(function () {
          if (_this4.bridges[mac].authUsername === _this4.bridges[mac].username && _this4.bridges[mac].authPassword === _this4.bridges[mac].password) {
            _this4.bridges[mac].isAuthenticating = 0;
            _this4.bridges[mac].isAuthenticated = 1;
          } else {
            _this4.bridges[mac].isAuthenticating = 0;
            _this4.bridges[mac].isAuthenticated = 0;
            _this4.bridges[mac].authError = 'Wrong username or password';
          }
        }, 1000);
      } else {
        this.bridges[mac].authError = 'Enter username and password';
      }
    },
    onClickBridge: function onClickBridge(mac) {
      this.selectBridge(mac);
      this.onClickAllCamera();
    },
    selectBridge: function selectBridge(mac) {
      this.selectedBridge = mac;
    },
    selectCamera: function selectCamera(mac) {
      this.selectedCamera = mac;
    },
    unselectCamera: function unselectCamera() {
      this.selectedCamera = null;
    },
    onClickCamera: function onClickCamera(mac) {
      this.selectCamera(mac);
      // this.closeMenu()
      this.openCameraComponent();
    },
    onClickMenu: function onClickMenu() {
      this.isMenuActive = !this.isMenuActive;
    },
    openMenu: function openMenu() {
      this.isMenuActive = true;
    },
    closeMenu: function closeMenu() {
      this.isMenuActive = false;
    },
    onClickAllCamera: function onClickAllCamera() {
      this.unselectCamera();
      this.closeMenu();
    },
    onClickPlaybackTime: function onClickPlaybackTime() {
      if (this.isPlaybackTimePickerClosed) {
        this.openPlaybackTimePicker();
      } else {
        this.closePlaybackTimePicker();
      }
    },
    openPlaybackTimePicker: function openPlaybackTimePicker() {
      this.isPlaybackTimePickerClosed = false;
    },
    closePlaybackTimePicker: function closePlaybackTimePicker() {
      this.isPlaybackTimePickerClosed = true;
    },
    openCameraComponent: function openCameraComponent() {
      this.isCameraComponentClosed = false;
    },
    closeCameraComponent: function closeCameraComponent() {
      this.isCameraComponentClosed = true;
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading'
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HScrollComp__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HScrollComp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__HScrollComp__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'playback-time-picker-comp',
  components: { HScrollComp: __WEBPACK_IMPORTED_MODULE_0__HScrollComp___default.a },
  created: function created() {
    this.initializeMockupData();
  },
  beforeDestroy: function beforeDestroy() {
    this.pauseThumbnailVideo();
  },
  data: function data() {
    return {
      tabs: ['video', 'time-lapse'],
      selectedTabIndex: 0,
      dates: [],
      hours: [],
      minutes: [],
      recordingVideoUrls: [],
      thumbnailVideoUrls: [],
      selectedDateIndex: null,
      selectedHourIndex: null,
      selectedMinuteIndex: null,
      oneHourInThumbnailVideo: 1 / 30 * 60, // 1min / 30fps * 60mins
      oneMinuteInThumbnailVideo: 1 / 30, // 1min / 30fps
      syncingThumbnailVideoCurrentTimeWithTimeline$i: null,
      syncingRecordingVideoCurrentTimeWithTimeline$i: null,
      isThumbnailVideoPaused: true,
      isThumbnailVideoLoaded: false,
      isRecordingVideoPaused: true,
      isRecordingVideoLoaded: false,
      recordingVideoPlaybackRates: [0.5, 1, 2, 4],
      recordingVideoDefaultPlaybackRateIndex: 0,
      thumbnailVideoPlaybackRates: [0.1, 0.3, 0.5, 1, 2, 4, 8],
      thumbnailVideoDefaultPlaybackRateIndex: 0
    };
  },

  methods: {
    close: function close() {
      this.$emit('onClose', null);
    },
    selectTab: function selectTab(index) {
      if (this.tabs[index]) {
        this.selectedTabIndex = index;
      }
    },
    initializeTheWayRecordingVideoShow: function initializeTheWayRecordingVideoShow(src) {
      if (this.$refs.recordingVideo) {
        if (src) {
          this.$refs.recordingVideo.src = src;
          this.$refs.recordingVideo.controls = false;
          this.setRecordingVideoDefaultPlaybackRate();
          this.isRecordingVideoLoaded = false;
          this.$refs.recordingVideo.onloadedmetadata = function () {
            this.onLoadedRecordingVideoMetadata();
          }.bind(this);
          this.$refs.recordingVideo.onpause = function () {
            this.pauseRecordingVideo();
          }.bind(this);
          this.$refs.recordingVideo.load();
        } else {
          this.$refs.recordingVideo.src = '';
        }
      }
    },
    initializeTheWayThumbnailVideoShow: function initializeTheWayThumbnailVideoShow(src) {
      if (this.$refs.thumbnailVideo) {
        if (src) {
          this.$refs.thumbnailVideo.src = src;
          this.$refs.thumbnailVideo.controls = false;
          this.setThumbnailVideoDefaultPlaybackRate();
          this.isThumbnailVideoLoaded = false;
          this.$refs.thumbnailVideo.onloadedmetadata = function () {
            this.onLoadedThumbnailVideoMetadata();
          }.bind(this);
          this.$refs.thumbnailVideo.onpause = function () {
            this.pauseThumbnailVideo();
          }.bind(this);
          this.$refs.thumbnailVideo.load();
        } else {
          this.$refs.thumbnailVideo.src = '';
        }
      }
    },
    setRecordingVideoDefaultPlaybackRate: function setRecordingVideoDefaultPlaybackRate(rate) {
      if (this.$refs.recordingVideo) {
        this.$refs.recordingVideo.defaultPlaybackRate = this.recordingVideoPlaybackRates[this.recordingVideoDefaultPlaybackRateIndex];
        this.$refs.recordingVideo.playbackRate = this.recordingVideoPlaybackRates[this.recordingVideoDefaultPlaybackRateIndex];
      }
    },
    setThumbnailVideoDefaultPlaybackRate: function setThumbnailVideoDefaultPlaybackRate(rate) {
      if (this.$refs.thumbnailVideo) {
        this.$refs.thumbnailVideo.defaultPlaybackRate = this.thumbnailVideoPlaybackRates[this.thumbnailVideoDefaultPlaybackRateIndex];
        this.$refs.thumbnailVideo.playbackRate = this.thumbnailVideoPlaybackRates[this.thumbnailVideoDefaultPlaybackRateIndex];
      }
    },
    onLoadedRecordingVideoMetadata: function onLoadedRecordingVideoMetadata() {
      var _this = this;

      this.isRecordingVideoLoaded = true;
      if (this.selectedHourIndex !== null && this.selectedMinuteIndex !== null) {
        var videoCurrentTime = this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo;
        this.updateVideoCurrentTime(videoCurrentTime);
        setTimeout(function () {
          _this.resetTimeIndexes();
        }, 300);
      }
      if (this.isRecordingVideoPaused) {
        this.pauseRecordingVideo();
      } else {
        this.playRecordingVideo();
      }
    },
    onLoadedThumbnailVideoMetadata: function onLoadedThumbnailVideoMetadata() {
      var _this2 = this;

      this.isThumbnailVideoLoaded = true;
      if (this.selectedHourIndex !== null && this.selectedMinuteIndex !== null) {
        var videoCurrentTime = this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo;
        this.updateVideoCurrentTime(videoCurrentTime);
        setTimeout(function () {
          _this2.resetTimeIndexes();
        }, 300);
      }
      if (this.isThumbnailVideoPaused) {
        this.pauseThumbnailVideo();
      } else {
        this.playThumbnailVideo();
      }
    },
    getAmPm: function getAmPm(hourIndex) {
      if (hourIndex < 12) return 'AM';else return 'PM';
    },
    initializeMockupData: function initializeMockupData() {
      var _this3 = this;

      this.dates = [];
      for (var i = 31; i > 0; i--) {
        this.dates.push('May ' + i);
      }
      this.hours = [];
      for (var _i = 0; _i < 24; _i++) {
        this.hours.push(_i === 0 ? '12' : _i < 12 ? _i : _i === 12 ? '12' : _i - 12);
      }
      this.minutes = [];
      for (var _i2 = 0; _i2 < 60; _i2++) {
        this.minutes.push(_i2 < 10 ? '0' + _i2 : _i2 + '');
      }
      this.recordingVideoUrls = ['https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-0.mp4', 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-1.mp4', 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-2.mp4'];
      this.thumbnailVideoUrls = ['https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-0.mp4', 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-1.mp4', 'https://s3-us-west-2.amazonaws.com/chektdev-video-sample/thumbnail-video-2.mp4'];
      this.$nextTick(function () {
        _this3.selectDate(0);
        _this3.selectHour(0);
        _this3.selectMinute(0);
      });
    },
    onClickDate: function onClickDate(dateIndex) {
      this.selectDate(dateIndex);
    },
    selectDate: function selectDate(dateIndex) {
      if (this.selectedDateIndex !== dateIndex) {
        if (this.thumbnailVideoUrls[dateIndex]) {
          this.initializeTheWayThumbnailVideoShow(this.thumbnailVideoUrls[dateIndex]);
          this.initializeTheWayRecordingVideoShow(this.recordingVideoUrls[dateIndex]);
          this.selectedDateIndex = dateIndex;
        } else {
          this.pauseThumbnailVideo();
          this.selectedDateIndex = dateIndex;
        }
      }
    },
    onClickHour: function onClickHour(hourIndex) {
      var _this4 = this;

      this.selectHour(hourIndex);
      var videoCurrentTime = hourIndex * this.oneHourInThumbnailVideo + this.selectedMinuteIndex * this.oneMinuteInThumbnailVideo;
      this.updateVideoCurrentTime(videoCurrentTime);
      // this.onClickMinute(0)
      setTimeout(function () {
        _this4.resetTimeIndexes();
      }, 300);
    },
    selectHour: function selectHour(hourIndex) {
      this.selectedHourIndex = hourIndex;
    },
    onClickMinute: function onClickMinute(timeIndex) {
      var _this5 = this;

      this.selectMinute(timeIndex);
      var videoCurrentTime = timeIndex * this.oneMinuteInThumbnailVideo + this.selectedHourIndex * this.oneHourInThumbnailVideo;
      this.updateVideoCurrentTime(videoCurrentTime);
      setTimeout(function () {
        _this5.resetTimeIndexes();
      }, 300);
    },
    selectMinute: function selectMinute(timeIndex) {
      this.selectedMinuteIndex = timeIndex;
    },
    updateVideoCurrentTime: function updateVideoCurrentTime(time) {
      if (this.$refs.thumbnailVideo) {
        this.$refs.thumbnailVideo.currentTime = time + 0.001;
      }
    },
    onClickActionBtnForRecordingVideo: function onClickActionBtnForRecordingVideo() {
      if (this.$refs.recordingVideo) {
        if (this.$refs.recordingVideo.paused) this.playRecordingVideo();else this.pauseRecordingVideo();
      }
    },
    onClickActionBtnForThumbnailVideo: function onClickActionBtnForThumbnailVideo() {
      if (this.$refs.thumbnailVideo) {
        if (this.$refs.thumbnailVideo.paused) this.playThumbnailVideo();else this.pauseThumbnailVideo();
      }
    },
    playRecordingVideo: function playRecordingVideo() {
      if (this.$refs.recordingVideo && this.isRecordingVideoLoaded) {
        this.isRecordingVideoPaused = false;
        this.$refs.recordingVideo.play();
        this.startSyncingRecordingVideoCurrentTimeWithTimeline();
      }
    },
    pauseRecordingVideo: function pauseRecordingVideo() {
      if (this.$refs.recordingVideo) {
        this.isRecordingVideoPaused = true;
        this.$refs.recordingVideo.pause();
        this.stopSyncingRecordingVideoCurrentTimeWithTimeline();
      }
    },
    playThumbnailVideo: function playThumbnailVideo() {
      if (this.$refs.thumbnailVideo && this.isThumbnailVideoLoaded) {
        this.isThumbnailVideoPaused = false;
        this.$refs.thumbnailVideo.play();
        this.startSyncingThumbnailVideoCurrentTimeWithTimeline();
      }
    },
    pauseThumbnailVideo: function pauseThumbnailVideo() {
      if (this.$refs.thumbnailVideo) {
        this.isThumbnailVideoPaused = true;
        this.$refs.thumbnailVideo.pause();
        this.stopSyncingThumbnailVideoCurrentTimeWithTimeline();
      }
    },
    startSyncingRecordingVideoCurrentTimeWithTimeline: function startSyncingRecordingVideoCurrentTimeWithTimeline() {
      var _this6 = this;

      this.stopSyncingRecordingVideoCurrentTimeWithTimeline();
      this.syncingRecordingVideoCurrentTimeWithTimeline$i = setInterval(function () {
        _this6.resetTimeIndexes();
      }, 300);
    },
    stopSyncingRecordingVideoCurrentTimeWithTimeline: function stopSyncingRecordingVideoCurrentTimeWithTimeline() {
      if (this.syncingThumbnailVideoCurrentTimeWithTimeline$i) {
        clearInterval(this.syncingRecordingVideoCurrentTimeWithTimeline$i);
        this.resetTimeIndexes();
      }
    },
    startSyncingThumbnailVideoCurrentTimeWithTimeline: function startSyncingThumbnailVideoCurrentTimeWithTimeline() {
      var _this7 = this;

      this.stopSyncingThumbnailVideoCurrentTimeWithTimeline();
      this.syncingThumbnailVideoCurrentTimeWithTimeline$i = setInterval(function () {
        _this7.resetTimeIndexes();
      }, 300);
    },
    stopSyncingThumbnailVideoCurrentTimeWithTimeline: function stopSyncingThumbnailVideoCurrentTimeWithTimeline() {
      if (this.syncingThumbnailVideoCurrentTimeWithTimeline$i) {
        clearInterval(this.syncingThumbnailVideoCurrentTimeWithTimeline$i);
        this.resetTimeIndexes();
      }
    },
    resetTimeIndexes: function resetTimeIndexes() {
      if (this.$refs.thumbnailVideo) {
        var time = this.$refs.thumbnailVideo.currentTime;
        var minuteIndex = Math.floor(time / this.oneMinuteInThumbnailVideo);
        var hourIndex = Math.floor(time / this.oneHourInThumbnailVideo);
        minuteIndex = minuteIndex % this.minutes.length;
        hourIndex = hourIndex % this.hours.length;
        this.selectMinute(minuteIndex);
        this.selectHour(hourIndex);
      }
    },
    onClickRecordingVideoPlaybackRate: function onClickRecordingVideoPlaybackRate() {
      var index = this.recordingVideoDefaultPlaybackRateIndex + 1;
      if (index >= this.recordingVideoPlaybackRates.length) index = 0;
      this.recordingVideoDefaultPlaybackRateIndex = index;
      this.setRecordingVideoDefaultPlaybackRate();
    },
    onClickThumbnailVideoPlaybackRate: function onClickThumbnailVideoPlaybackRate() {
      var index = this.thumbnailVideoDefaultPlaybackRateIndex + 1;
      if (index >= this.thumbnailVideoPlaybackRates.length) index = 0;
      this.thumbnailVideoDefaultPlaybackRateIndex = index;
      this.setThumbnailVideoDefaultPlaybackRate();
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  data: function data() {
    return {
      isHistoryVisible: false,
      recentlyViewdMacAddresses: [],
      mockupMacAddresses: ['6EF403752355', 'CAF931D46A50', '70B6E8F8EB79', '514EFFA89A11', '7C781AB2151D']
    };
  },

  computed: {
    myName: function myName() {
      return this.$store.getters.myName;
    },
    mySites: function mySites() {
      return this.$store.getters.mySites;
    }
  },
  methods: {
    goToHome: function goToHome() {
      this.$router.push('home');
    },
    test: function test() {
      // this.$store.dispatch('getMyProfile')
      this.$store.dispatch('getMySites');
      // this.$auth.login()
    },
    getSiteCameras: function getSiteCameras(siteId) {
      this.$store.dispatch('getSiteCameras', siteId);
      this.$store.dispatch('getSiteMembers', siteId);
      this.$store.dispatch('getSiteContacts', siteId);
    },
    showHistory: function showHistory() {
      this.isHistoryVisible = true;
    },
    hideHistory: function hideHistory() {
      this.isHistoryVisible = false;
    }
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompMenu__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CompMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompToaster__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompToaster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CompToaster__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site',
  components: { CompMenu: __WEBPACK_IMPORTED_MODULE_0__CompMenu___default.a, CompToaster: __WEBPACK_IMPORTED_MODULE_1__CompToaster___default.a },
  created: function created() {
    var siteId = this.$route.params.siteId;
    console.log('siteId: ' + siteId);
  },
  computed: {
    isMenuActive: function isMenuActive() {
      return this.$store.getters.isMenuActive;
    },
    isOnline: function isOnline() {
      return this.$store.getters.isOnline;
    }
  },
  methods: {
    closeMenu: function closeMenu() {
      this.$store.commit('CLOSE_MENU');
    }
  }
});

/***/ }),
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports) {

module.exports = {"version":"2017b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|HMT +0630 IST|-5R.k -6u -5u|01212|-18LFR.k 1unn.k HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.E -6u -90|0121|-21Jio.E SmnS.E 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Etc/GMT+0|GMT|0|0|","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Khartoum|Africa/Juba","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/East-Saskatchewan","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT+0|Etc/GMT","Etc/GMT+0|Etc/GMT-0","Etc/GMT+0|Etc/GMT0","Etc/GMT+0|Etc/Greenwich","Etc/GMT+0|GMT","Etc/GMT+0|GMT+0","Etc/GMT+0|GMT-0","Etc/GMT+0|GMT0","Etc/GMT+0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 51,
	"./af.js": 51,
	"./ar": 58,
	"./ar-dz": 52,
	"./ar-dz.js": 52,
	"./ar-kw": 53,
	"./ar-kw.js": 53,
	"./ar-ly": 54,
	"./ar-ly.js": 54,
	"./ar-ma": 55,
	"./ar-ma.js": 55,
	"./ar-sa": 56,
	"./ar-sa.js": 56,
	"./ar-tn": 57,
	"./ar-tn.js": 57,
	"./ar.js": 58,
	"./az": 59,
	"./az.js": 59,
	"./be": 60,
	"./be.js": 60,
	"./bg": 61,
	"./bg.js": 61,
	"./bn": 62,
	"./bn.js": 62,
	"./bo": 63,
	"./bo.js": 63,
	"./br": 64,
	"./br.js": 64,
	"./bs": 65,
	"./bs.js": 65,
	"./ca": 66,
	"./ca.js": 66,
	"./cs": 67,
	"./cs.js": 67,
	"./cv": 68,
	"./cv.js": 68,
	"./cy": 69,
	"./cy.js": 69,
	"./da": 70,
	"./da.js": 70,
	"./de": 73,
	"./de-at": 71,
	"./de-at.js": 71,
	"./de-ch": 72,
	"./de-ch.js": 72,
	"./de.js": 73,
	"./dv": 74,
	"./dv.js": 74,
	"./el": 75,
	"./el.js": 75,
	"./en-au": 76,
	"./en-au.js": 76,
	"./en-ca": 77,
	"./en-ca.js": 77,
	"./en-gb": 78,
	"./en-gb.js": 78,
	"./en-ie": 79,
	"./en-ie.js": 79,
	"./en-nz": 80,
	"./en-nz.js": 80,
	"./eo": 81,
	"./eo.js": 81,
	"./es": 83,
	"./es-do": 82,
	"./es-do.js": 82,
	"./es.js": 83,
	"./et": 84,
	"./et.js": 84,
	"./eu": 85,
	"./eu.js": 85,
	"./fa": 86,
	"./fa.js": 86,
	"./fi": 87,
	"./fi.js": 87,
	"./fo": 88,
	"./fo.js": 88,
	"./fr": 91,
	"./fr-ca": 89,
	"./fr-ca.js": 89,
	"./fr-ch": 90,
	"./fr-ch.js": 90,
	"./fr.js": 91,
	"./fy": 92,
	"./fy.js": 92,
	"./gd": 93,
	"./gd.js": 93,
	"./gl": 94,
	"./gl.js": 94,
	"./gom-latn": 95,
	"./gom-latn.js": 95,
	"./he": 96,
	"./he.js": 96,
	"./hi": 97,
	"./hi.js": 97,
	"./hr": 98,
	"./hr.js": 98,
	"./hu": 99,
	"./hu.js": 99,
	"./hy-am": 100,
	"./hy-am.js": 100,
	"./id": 101,
	"./id.js": 101,
	"./is": 102,
	"./is.js": 102,
	"./it": 103,
	"./it.js": 103,
	"./ja": 104,
	"./ja.js": 104,
	"./jv": 105,
	"./jv.js": 105,
	"./ka": 106,
	"./ka.js": 106,
	"./kk": 107,
	"./kk.js": 107,
	"./km": 108,
	"./km.js": 108,
	"./kn": 109,
	"./kn.js": 109,
	"./ko": 110,
	"./ko.js": 110,
	"./ky": 111,
	"./ky.js": 111,
	"./lb": 112,
	"./lb.js": 112,
	"./lo": 113,
	"./lo.js": 113,
	"./lt": 114,
	"./lt.js": 114,
	"./lv": 115,
	"./lv.js": 115,
	"./me": 116,
	"./me.js": 116,
	"./mi": 117,
	"./mi.js": 117,
	"./mk": 118,
	"./mk.js": 118,
	"./ml": 119,
	"./ml.js": 119,
	"./mr": 120,
	"./mr.js": 120,
	"./ms": 122,
	"./ms-my": 121,
	"./ms-my.js": 121,
	"./ms.js": 122,
	"./my": 123,
	"./my.js": 123,
	"./nb": 124,
	"./nb.js": 124,
	"./ne": 125,
	"./ne.js": 125,
	"./nl": 127,
	"./nl-be": 126,
	"./nl-be.js": 126,
	"./nl.js": 127,
	"./nn": 128,
	"./nn.js": 128,
	"./pa-in": 129,
	"./pa-in.js": 129,
	"./pl": 130,
	"./pl.js": 130,
	"./pt": 132,
	"./pt-br": 131,
	"./pt-br.js": 131,
	"./pt.js": 132,
	"./ro": 133,
	"./ro.js": 133,
	"./ru": 134,
	"./ru.js": 134,
	"./sd": 135,
	"./sd.js": 135,
	"./se": 136,
	"./se.js": 136,
	"./si": 137,
	"./si.js": 137,
	"./sk": 138,
	"./sk.js": 138,
	"./sl": 139,
	"./sl.js": 139,
	"./sq": 140,
	"./sq.js": 140,
	"./sr": 142,
	"./sr-cyrl": 141,
	"./sr-cyrl.js": 141,
	"./sr.js": 142,
	"./ss": 143,
	"./ss.js": 143,
	"./sv": 144,
	"./sv.js": 144,
	"./sw": 145,
	"./sw.js": 145,
	"./ta": 146,
	"./ta.js": 146,
	"./te": 147,
	"./te.js": 147,
	"./tet": 148,
	"./tet.js": 148,
	"./th": 149,
	"./th.js": 149,
	"./tl-ph": 150,
	"./tl-ph.js": 150,
	"./tlh": 151,
	"./tlh.js": 151,
	"./tr": 152,
	"./tr.js": 152,
	"./tzl": 153,
	"./tzl.js": 153,
	"./tzm": 155,
	"./tzm-latn": 154,
	"./tzm-latn.js": 154,
	"./tzm.js": 155,
	"./uk": 156,
	"./uk.js": 156,
	"./ur": 157,
	"./ur.js": 157,
	"./uz": 159,
	"./uz-latn": 158,
	"./uz-latn.js": 158,
	"./uz.js": 159,
	"./vi": 160,
	"./vi.js": 160,
	"./x-pseudo": 161,
	"./x-pseudo.js": 161,
	"./yo": 162,
	"./yo.js": 162,
	"./zh-cn": 163,
	"./zh-cn.js": 163,
	"./zh-hk": 164,
	"./zh-hk.js": 164,
	"./zh-tw": 165,
	"./zh-tw.js": 165
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 257;

/***/ }),
/* 258 */,
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(247)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(277),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(240)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(270),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-06131fc1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(272),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(250)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(280),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-cb1fdd8a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(279),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-920e7330",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(246)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(276),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6905a1e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(275),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-57ceb29f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(269),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-051cab5c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(278),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7fd0bbd6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(241)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(271),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10b6a574",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "playback-time-picker-comp"
  }, [_c('div', {
    staticClass: "background",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "header"
  }, _vm._l((_vm.tabs), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "tab-btn",
      class: {
        selected: _vm.selectedTabIndex === index
      },
      on: {
        "click": function($event) {
          _vm.selectTab(index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(value) + "\n        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "camera-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs[_vm.selectedTabIndex] === 'time-lapse'),
      expression: "tabs[selectedTabIndex] === 'time-lapse'"
    }],
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.thumbnailVideoUrls[_vm.selectedDateIndex]),
      expression: "!thumbnailVideoUrls[selectedDateIndex]"
    }],
    staticClass: "no-recording-text"
  }, [_vm._v("No recording")]), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.thumbnailVideoUrls[_vm.selectedDateIndex]),
      expression: "thumbnailVideoUrls[selectedDateIndex]"
    }],
    ref: "thumbnailVideo",
    attrs: {
      "webkit-playsinline": "",
      "playsinline": ""
    }
  }), _vm._v(" "), (_vm.thumbnailVideoUrls[_vm.selectedDateIndex]) ? _c('div', {
    staticClass: "control-container"
  }, [_c('div', {
    staticClass: "play-stop-btn",
    class: {
      loading: !_vm.isThumbnailVideoLoaded
    },
    on: {
      "click": function($event) {
        _vm.onClickActionBtnForThumbnailVideo()
      }
    }
  }, [(!_vm.isThumbnailVideoLoaded) ? _c('div', [_vm._v("Loading...")]) : (!_vm.isThumbnailVideoPaused) ? _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]) : _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "playback-rate-btn",
    on: {
      "click": function($event) {
        _vm.onClickThumbnailVideoPlaybackRate()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.thumbnailVideoPlaybackRates[_vm.thumbnailVideoDefaultPlaybackRateIndex] + 'x') + " \n              ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs[_vm.selectedTabIndex] === 'video'),
      expression: "tabs[selectedTabIndex] === 'video'"
    }],
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.recordingVideoUrls[_vm.selectedDateIndex]),
      expression: "!recordingVideoUrls[selectedDateIndex]"
    }],
    staticClass: "no-recording-text"
  }, [_vm._v("No recording")]), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recordingVideoUrls[_vm.selectedDateIndex]),
      expression: "recordingVideoUrls[selectedDateIndex]"
    }],
    ref: "recordingVideo",
    attrs: {
      "webkit-playsinline": "",
      "playsinline": ""
    }
  }), _vm._v(" "), (_vm.recordingVideoUrls[_vm.selectedDateIndex]) ? _c('div', {
    staticClass: "control-container"
  }, [_c('div', {
    staticClass: "play-stop-btn",
    class: {
      loading: !_vm.isRecordingVideoLoaded
    },
    on: {
      "click": function($event) {
        _vm.onClickActionBtnForRecordingVideo()
      }
    }
  }, [(!_vm.isRecordingVideoLoaded) ? _c('div', [_vm._v("Loading...")]) : (!_vm.isRecordingVideoPaused) ? _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]) : _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "playback-rate-btn",
    on: {
      "click": function($event) {
        _vm.onClickRecordingVideoPlaybackRate()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.recordingVideoPlaybackRates[_vm.recordingVideoDefaultPlaybackRateIndex] + 'x') + " \n              ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "timeline-container"
  }, [_c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n               \n            "), _c('h-scroll-comp', {
    attrs: {
      "itemWidth": 100,
      "selectedItem": _vm.selectedDateIndex,
      "totalItems": _vm.dates.length
    }
  }, _vm._l((_vm.dates), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        'selected': index === _vm.selectedDateIndex,
          'has-recording': _vm.thumbnailVideoUrls[index]
      },
      on: {
        "click": function($event) {
          _vm.onClickDate(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(value) + "\n              ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n               \n            "), _c('h-scroll-comp', {
    attrs: {
      "itemWidth": 100,
      "selectedItem": _vm.selectedHourIndex,
      "totalItems": _vm.hours.length
    }
  }, _vm._l((_vm.hours), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        selected: index === _vm.selectedHourIndex
      },
      on: {
        "click": function($event) {
          _vm.onClickHour(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(value + _vm.getAmPm(index)) + "\n              ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n               \n            "), _c('h-scroll-comp', {
    attrs: {
      "itemWidth": 100,
      "selectedItem": _vm.selectedMinuteIndex,
      "totalItems": _vm.minutes.length
    }
  }, _vm._l((_vm.minutes), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        selected: index === _vm.selectedMinuteIndex
      },
      on: {
        "click": function($event) {
          _vm.onClickMinute(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(value) + "\n              ")])
  }))], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "footer",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("\n        Close\n      ")])])])])
},staticRenderFns: []}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camera-comp"
  }, [_c('div', {
    staticClass: "background",
    class: {
      'full-screen': _vm.isFullSceenActive
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFullSceenActive),
      expression: "!isFullSceenActive"
    }],
    staticClass: "header"
  }, [_c('div', {
    staticClass: "back-btn",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "header-title"
  }, [_vm._v(_vm._s(_vm.cameraObj.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "main",
    class: {
      'full-screen': _vm.isFullSceenActive
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "camera-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs[_vm.selectedTabIndex] === 'live'),
      expression: "tabs[selectedTabIndex] === 'live'"
    }],
    staticClass: "content"
  }, [(!_vm.cameraObj.isOnline) ? _c('div', {
    staticClass: "svg-icon",
    on: {
      "click": function($event) {
        _vm.disableFullSceen()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0zm0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.cameraObj.isOnline) ? _c('img', {
    attrs: {
      "src": _vm.cameraObj.liveSnapshotUrl
    },
    on: {
      "click": function($event) {
        _vm.disableFullSceen()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.thumbnailVideoUrls[_vm.selectedDateIndex] && !_vm.isFullSceenActive) ? _c('div', {
    staticClass: "control-container"
  }, [_c('div', {
    staticClass: "clickable-layer",
    on: {
      "click": function($event) {
        _vm.enableFullSceen()
      }
    }
  }), _vm._v(" "), (!_vm.isThumbnailVideoLoaded) ? _c('div', {
    staticClass: "loading-status"
  }, [_vm._v("\n              Loading...\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "video-info"
  }, [_c('div', {
    staticClass: "info-title",
    class: {
      'playback': _vm.tabs[_vm.selectedTabIndex] === 'playback'
    },
    on: {
      "click": function($event) {
        _vm.toggleTab()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.tabs[_vm.selectedTabIndex]) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_vm._v("\n                " + _vm._s(_vm.hours[_vm.selectedHourIndex] + ':' + _vm.minutes[_vm.selectedMinuteIndex] + ':00 ' + _vm.getAmPm(_vm.selectedHourIndex)) + "\n              ")])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs[_vm.selectedTabIndex] === 'playback'),
      expression: "tabs[selectedTabIndex] === 'playback'"
    }],
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.thumbnailVideoUrls[_vm.selectedDateIndex]),
      expression: "!thumbnailVideoUrls[selectedDateIndex]"
    }],
    staticClass: "no-recording-text"
  }, [_vm._v("No recording")]), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.thumbnailVideoUrls[_vm.selectedDateIndex]),
      expression: "thumbnailVideoUrls[selectedDateIndex]"
    }],
    ref: "thumbnailVideo",
    attrs: {
      "webkit-playsinline": "",
      "playsinline": ""
    },
    on: {
      "click": function($event) {
        _vm.disableFullSceen()
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.thumbnailVideoUrls[_vm.selectedDateIndex] && !_vm.isFullSceenActive),
      expression: "thumbnailVideoUrls[selectedDateIndex] && !isFullSceenActive"
    }],
    staticClass: "control-container"
  }, [_c('div', {
    staticClass: "clickable-layer",
    on: {
      "click": function($event) {
        _vm.enableFullSceen()
      }
    }
  }), _vm._v(" "), (!_vm.isThumbnailVideoLoaded) ? _c('div', {
    staticClass: "loading-status"
  }, [_vm._v("\n              Loading...\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isThumbnailVideoLoaded) ? _c('div', {
    staticClass: "video-info",
    class: {
      'playback': _vm.tabs[_vm.selectedTabIndex] === 'playback'
    }
  }, [_c('div', {
    staticClass: "info-title",
    on: {
      "click": function($event) {
        _vm.toggleTab()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.isRecordingVideoActive ? _vm.tabs[_vm.selectedTabIndex] : (+_vm.thumbnailVideoPlaybackRates[_vm.thumbnailVideoDefaultPlaybackRateIndex] * 10 * 60) + 'x') + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_vm._v("\n                " + _vm._s(_vm.hours[_vm.selectedHourIndex] + ':' + _vm.minutes[_vm.selectedMinuteIndex] + ':00 ' + _vm.getAmPm(_vm.selectedHourIndex)) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.isThumbnailVideoLoaded) ? _c('div', {
    staticClass: "playback-control-container"
  }, [_c('div', {
    staticClass: "control-btn"
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "id": "a"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "b"
    }
  }, [_c('use', {
    attrs: {
      "overflow": "visible",
      "xlink:href": "#a"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "clip-path": "url(#b)",
      "d": "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-btn",
    on: {
      "click": function($event) {
        _vm.onClickFastRewind()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-btn",
    on: {
      "click": function($event) {
        _vm.onClickPlayAndPause()
      }
    }
  }, [(!_vm.isThumbnailVideoPaused) ? _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]) : _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-btn",
    on: {
      "click": function($event) {
        _vm.onClickFastForward()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-btn"
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M24 24H0V0h24v24z",
      "id": "a"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "b"
    }
  }, [_c('use', {
    attrs: {
      "overflow": "visible",
      "xlink:href": "#a"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "clip-path": "url(#b)",
      "d": "M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
    }
  })])])]) : _vm._e()])])], 1)])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFullSceenActive),
      expression: "!isFullSceenActive"
    }],
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "camera-control-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs[_vm.selectedTabIndex] === 'playback'),
      expression: "tabs[selectedTabIndex] === 'playback'"
    }],
    staticClass: "timeline-container"
  }, [_c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n             \n          "), _c('h-scroll-comp', {
    attrs: {
      "refreshTrigger": _vm.refreshHScrollCompCount,
      "itemWidth": 100,
      "selectedItem": _vm.selectedDateIndex,
      "totalItems": _vm.dates.length
    }
  }, _vm._l((_vm.dates), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        'selected': index === _vm.selectedDateIndex,
          'has-recording': _vm.thumbnailVideoUrls[index]
      },
      on: {
        "click": function($event) {
          _vm.onClickDate(index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(value) + "\n            ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n             \n          "), _c('h-scroll-comp', {
    attrs: {
      "refreshTrigger": _vm.refreshHScrollCompCount,
      "itemWidth": 100,
      "selectedItem": _vm.selectedHourIndex,
      "totalItems": _vm.hours.length
    }
  }, _vm._l((_vm.hours), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        selected: index === _vm.selectedHourIndex
      },
      on: {
        "click": function($event) {
          _vm.onClickHour(index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(value + _vm.getAmPm(index)) + "\n            ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n             \n          "), _c('h-scroll-comp', {
    attrs: {
      "refreshTrigger": _vm.refreshHScrollCompCount,
      "itemWidth": 100,
      "selectedItem": _vm.selectedMinuteIndex,
      "totalItems": _vm.minutes.length
    }
  }, _vm._l((_vm.minutes), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        selected: index === _vm.selectedMinuteIndex
      },
      on: {
        "click": function($event) {
          _vm.onClickMinute(index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(value) + "\n            ")])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "action-btns"
  }, _vm._l((_vm.tabs), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "action-btn",
      class: {
        'selected': index === _vm.selectedTabIndex,
          'playback': value === 'playback'
      },
      on: {
        "click": function($event) {
          _vm.selectTab(index)
        }
      }
    }, [_vm._v(_vm._s(value))])
  }))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site",
    class: {
      menuVisible: _vm.isMenuActive
    }
  }, [_c('comp-menu'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('comp-toaster'), _vm._v(" "), _c('div', {
    staticClass: "clickable-layer-to-close-menu",
    on: {
      "click": function($event) {
        _vm.closeMenu()
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [(!_vm.isOnline) ? _c('div', {
    staticClass: "unclickable-layer-to-close-menu"
  }, [_vm._v("\n    Check network connection\n  ")]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cameras",
    class: {
      menuVisible: _vm.isMenuActive
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "menu-btn",
    class: {
      active: _vm.isMenuActive
    },
    attrs: {
      "ontouchstart": ""
    },
    on: {
      "click": function($event) {
        _vm.onClickMenu()
      }
    }
  }, [_c('div', {
    staticClass: "bar first"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bar second"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bar third"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bar fourth"
  }, [_vm._v(" ")])]), _vm._v(" "), (_vm.currentSiteId) ? _c('div', {
    staticClass: "header-title"
  }, [_vm._v("\n      " + _vm._s(_vm.currentSite.localTimeNow().toLocaleTimeString()) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "option-btns"
  }, [_c('div', {
    staticClass: "option-btn",
    class: {
      'disabled': _vm.snapshotMaxWidthIndexInUse <= 0
    },
    attrs: {
      "ontouchstart": ""
    },
    on: {
      "click": function($event) {
        _vm.onClickZoomOut()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "option-btn",
    class: {
      'disabled': _vm.snapshotMaxWidthIndexInUse >= _vm.snapshotMaxWidthSizes.length - 1
    },
    attrs: {
      "ontouchstart": ""
    },
    on: {
      "click": function($event) {
        _vm.onClickZoomIn()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(_vm.currentSiteId) ? _c('div', {
    staticClass: "cameras-container"
  }, [_c('transition', {
    attrs: {
      "name": "moveup",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.currentSite.cameras) ? _c('span', _vm._l((_vm.currentSite.cameras), function(cameraId) {
    return _c('div', {
      key: cameraId,
      staticClass: "camera-container",
      class: {
        'has-event': _vm.cameraIdsWithEvents[cameraId]
      },
      style: ({
        'max-width': _vm.snapshotMaxWidthSizes[_vm.snapshotMaxWidthIndexInUse] + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.onClickCamera(cameraId)
        }
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "camera-info"
    }, [_c('div', {
      staticClass: "camera-name prevent-text-overflow"
    }, [_c('svg', {
      attrs: {
        "fill": "#FFFFFF",
        "height": "48",
        "viewBox": "0 0 24 24",
        "width": "48",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
      }
    })]), _vm._v("\n                " + _vm._s(_vm.camera(cameraId).name) + "\n              ")]), _vm._v(" "), (_vm.camera(cameraId).isOnline) ? _c('div', {
      staticClass: "updated-info"
    }, [_c('div', {
      staticClass: "updated-info-description"
    }, [_vm._v("\n                  Last updated\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "updated-info-time"
    }, [_vm._v("\n                  " + _vm._s(_vm.liveSnapshot(cameraId) ? _vm.currentSite.convertToLocalTime(_vm.liveSnapshot(cameraId).timestamp).toLocaleTimeString() :
      _vm.statusGetLiveSnapshot(cameraId) === 'requested' ? 'loading...' : 'no info') + "\n                ")])]) : _c('div', {
      staticClass: "updated-info"
    }, [_c('div', {
      staticClass: "updated-info-description"
    }, [_vm._v("\n                  Status\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "updated-info-time"
    }, [_vm._v("\n                  Offline\n                ")])])]), _vm._v(" "), (!_vm.camera(cameraId).isOnline) ? _c('div', {
      staticClass: "svg-icon"
    }, [_c('svg', {
      attrs: {
        "fill": "#FFFFFF",
        "height": "48",
        "viewBox": "0 0 24 24",
        "width": "48",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0zm0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.camera(cameraId).isOnline && _vm.liveSnapshot(cameraId)) ? _c('img', {
      attrs: {
        "src": _vm.liveSnapshot(cameraId).url
      }
    }) : _vm._e(), _vm._v(" "), (_vm.camera(cameraId).isContinuousRecordingEnabled) ? _c('div', {
      staticClass: "recording-dot",
      class: {
        'inactive': !_vm.camera(cameraId).isOnline
      }
    }, [_vm._v("REC")]) : _vm._e(), _vm._v(" "), (_vm.camera(cameraId).isOnline && _vm.liveSnapshot(cameraId)) ? _c('div', {
      staticClass: "old-snapshot-overlay",
      class: {
        'visible': _vm.nowTimestamp - _vm.liveSnapshot(cameraId).timestamp > 1000 * 60
      }
    }, [_vm._v("Old snapshot")]) : _vm._e()])])
  })) : _vm._e()])], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-scroll-comp"
  }, [_c('div', {
    staticClass: "inner-wrapper",
    style: ({
      width: _vm.itemWidth * _vm.totalItems + 'px',
      transform: 'translateX(' + (+_vm.xPosition - +_vm.itemWidth / 2) + 'px)'
    }),
    on: {
      "mousewheel": function($event) {
        _vm.convertScrollToVertical($event)
      },
      "touchstart": function($event) {
        _vm.onTouchStart($event)
      },
      "touchmove": function($event) {
        _vm.onTouchMove($event)
      }
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    },
    on: {
      "touchmove": function($event) {
        _vm.preventPinchZoom($event)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n  Loading data...\n")])
},staticRenderFns: []}

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: {
      menuVisible: _vm.isMenuActive
    }
  }, [(!_vm.isPlaybackTimePickerClosed) ? _c('div', {
    staticClass: "playback-time-picker-comp-container"
  }, [_c('playback-time-picker-comp', {
    on: {
      "onClose": function($event) {
        _vm.closePlaybackTimePicker()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "moveup",
      "mode": "out-in",
      "appear": ""
    }
  }, [(!_vm.isCameraComponentClosed) ? _c('camera-comp', {
    attrs: {
      "cameraObj": _vm.channels[_vm.selectedCamera],
      "isActive": !_vm.isCameraComponentClosed
    },
    on: {
      "onClose": function($event) {
        _vm.closeCameraComponent()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clickable-layer-to-close-menu",
    class: {
      menuVisible: _vm.isMenuActive
    },
    on: {
      "click": function($event) {
        _vm.closeMenu()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "menu-items"
  }, [_c('div', {
    staticClass: "menu-category"
  }, [_vm._v("Site")]), _vm._v(" "), _vm._l((_vm.mySites), function(site, siteId) {
    return _c('div', {
      key: siteId,
      staticClass: "menu-item",
      attrs: {
        "ontouchstart": ""
      },
      on: {
        "click": function($event) {
          _vm.selectSite(siteId)
        }
      }
    }, [_c('div', {
      staticClass: "menu-icon"
    }, [_c('svg', {
      attrs: {
        "fill": "#FFFFFF",
        "height": "48",
        "viewBox": "0 0 24 24",
        "width": "48",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "menu-info"
    }, [_c('div', {
      staticClass: "main-info"
    }, [_vm._v(_vm._s(site.name))]), _vm._v(" "), _c('div', {
      staticClass: "sub-info"
    }, [_vm._v(_vm._s(site.address))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "menu-btn",
    class: {
      active: _vm.isMenuActive
    },
    attrs: {
      "ontouchstart": ""
    },
    on: {
      "click": function($event) {
        _vm.onClickMenu()
      }
    }
  }, [_c('div', {
    staticClass: "bar first"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bar second"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bar third"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "bar fourth"
  }, [_vm._v(" ")])]), _vm._v(" "), (_vm.currentSiteId) ? _c('div', {
    staticClass: "header-title"
  }, [_vm._v("\n        " + _vm._s(_vm.currentSite.localTimeNow().toLocaleTimeString()) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(!_vm.bridges[_vm.selectedBridge].isOnline) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "offline-container"
  }, [_c('div', {
    staticClass: "status-text"
  }, [_vm._v("Can't connect to the bridge.")]), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    class: {
      'disable-click': _vm.bridges[_vm.selectedBridge].isCheckingConnection
    },
    on: {
      "click": function($event) {
        _vm.checkBridgeConnection(_vm.selectedBridge)
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]), _vm._v("\n            " + _vm._s(_vm.bridges[_vm.selectedBridge].isCheckingConnection ? 'Checking status...' : 'Refresh status') + "\n          ")])])]) : (!_vm.bridges[_vm.selectedBridge].isAuthenticated) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "authentication-container"
  }, [_c('div', {
    staticClass: "status-text"
  }, [_vm._v("Authentication")]), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bridges[_vm.selectedBridge].authUsername),
      expression: "bridges[selectedBridge].authUsername"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter username"
    },
    domProps: {
      "value": (_vm.bridges[_vm.selectedBridge].authUsername)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.authenticateBridgeConnection(_vm.selectedBridge)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bridges[_vm.selectedBridge].authUsername = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bridges[_vm.selectedBridge].authPassword),
      expression: "bridges[selectedBridge].authPassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Enter password"
    },
    domProps: {
      "value": (_vm.bridges[_vm.selectedBridge].authPassword)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.authenticateBridgeConnection(_vm.selectedBridge)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bridges[_vm.selectedBridge].authPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "action-btn",
    class: {
      'disable-click': _vm.bridges[_vm.selectedBridge].isAuthenticating
    },
    on: {
      "click": function($event) {
        _vm.authenticateBridgeConnection(_vm.selectedBridge)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.bridges[_vm.selectedBridge].isAuthenticating ? 'Authenticating...' : 'Authenticate') + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "error-text",
    class: {
      'visible': _vm.bridges[_vm.selectedBridge].authError
    }
  }, [_vm._v("\n            " + _vm._s(_vm.bridges[_vm.selectedBridge].authError ? _vm.bridges[_vm.selectedBridge].authError : 'no message') + "\n          ")])])]) : _c('div', {
    staticClass: "wrapper"
  }, [(_vm.currentSiteId) ? _c('div', {
    staticClass: "cameras-container"
  }, _vm._l((_vm.currentSite.cameras), function(cameraId) {
    return _c('div', {
      key: cameraId,
      staticClass: "camera-container"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "camera-info"
    }, [_c('div', {
      staticClass: "camera-name prevent-text-overflow"
    }, [_c('svg', {
      attrs: {
        "fill": "#FFFFFF",
        "height": "48",
        "viewBox": "0 0 24 24",
        "width": "48",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
      }
    })]), _vm._v("\n                  " + _vm._s(_vm.camera(cameraId).name) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "updated-info"
    }, [_c('div', {
      staticClass: "updated-info-description"
    }, [_vm._v("Last updated")]), _vm._v(" "), _c('div', {
      staticClass: "updated-info-time"
    }, [_vm._v("\n                    " + _vm._s(_vm.liveSnapshot(cameraId) ? _vm.currentSite.convertToLocalTime(_vm.liveSnapshot(cameraId).timestamp).toLocaleTimeString() : 'no info') + "\n                  ")])])]), _vm._v(" "), (!_vm.camera(cameraId).isOnline) ? _c('div', {
      staticClass: "svg-icon"
    }, [_c('svg', {
      attrs: {
        "fill": "#FFFFFF",
        "height": "48",
        "viewBox": "0 0 24 24",
        "width": "48",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0zm0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.camera(cameraId).isOnline && _vm.liveSnapshot(cameraId)) ? _c('img', {
      attrs: {
        "src": 'data:image/jpg;base64,' + _vm.liveSnapshot(cameraId).url
      }
    }) : _vm._e()])])
  })) : _vm._e()])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camera",
    class: {
      'full-screen': _vm.isFullSceenActive
    }
  }, [(_vm.currentCameraId) ? [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFullSceenActive),
      expression: "!isFullSceenActive"
    }],
    staticClass: "header"
  }, [_c('div', {
    staticClass: "close-btn",
    class: {
      active: _vm.isMenuActive
    },
    attrs: {
      "ontouchstart": ""
    },
    on: {
      "click": function($event) {
        _vm.onClickClose()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "header-title"
  }, [_vm._v("\n        " + _vm._s(_vm.currentCamera.name) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "camera-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs[_vm.selectedTabIndex] === 'live'),
      expression: "tabs[selectedTabIndex] === 'live'"
    }],
    staticClass: "content"
  }, [(!_vm.currentCamera.isOnline) ? _c('div', {
    staticClass: "svg-icon",
    on: {
      "click": function($event) {
        _vm.disableFullSceen()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0zm0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.currentCamera.isOnline && _vm.currentCameraLiveSnapshot) ? _c('img', {
    attrs: {
      "src": _vm.currentCameraLiveSnapshot.url
    },
    on: {
      "click": function($event) {
        _vm.disableFullSceen()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(!_vm.isFullSceenActive) ? _c('div', {
    staticClass: "control-container"
  }, [_c('div', {
    staticClass: "clickable-layer",
    on: {
      "click": function($event) {
        _vm.enableFullSceen()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-info"
  }, [_c('div', {
    staticClass: "info-title",
    class: {
      'playback': _vm.tabs[_vm.selectedTabIndex] === 'playback'
    },
    on: {
      "click": function($event) {
        _vm.toggleTab()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.tabs[_vm.selectedTabIndex]) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.currentCameraLiveSnapshot ? _vm.currentSite.convertToLocalTime(_vm.currentCameraLiveSnapshot.timestamp).toLocaleTimeString() :
    _vm.currentCameraStatusGetLiveSnapshot === 'requested' ? 'loading...' :
    !_vm.currentCamera.isOnline ? 'offline' : 'no info') + "\n                ")])])]) : _vm._e()])], 1), _vm._v(" "), (_vm.currentCamera.thumbnailVideos) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs[_vm.selectedTabIndex] === 'playback'),
      expression: "tabs[selectedTabIndex] === 'playback'"
    }],
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.thumbnailVideo(_vm.currentCamera.thumbnailVideos[_vm.dates[_vm.selectedDateIndex]])),
      expression: "!thumbnailVideo(currentCamera.thumbnailVideos[dates[selectedDateIndex]])"
    }],
    staticClass: "no-recording-text"
  }, [_vm._v("No recording")]), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.thumbnailVideo(_vm.currentCamera.thumbnailVideos[_vm.dates[_vm.selectedDateIndex]])),
      expression: "thumbnailVideo(currentCamera.thumbnailVideos[dates[selectedDateIndex]])"
    }],
    ref: "thumbnailVideo",
    attrs: {
      "webkit-playsinline": "",
      "playsinline": ""
    },
    on: {
      "click": function($event) {
        _vm.disableFullSceen()
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.thumbnailVideo(_vm.currentCamera.thumbnailVideos[_vm.dates[_vm.selectedDateIndex]]) && !_vm.isFullSceenActive),
      expression: "thumbnailVideo(currentCamera.thumbnailVideos[dates[selectedDateIndex]]) && !isFullSceenActive"
    }],
    staticClass: "control-container"
  }, [_c('div', {
    staticClass: "clickable-layer",
    on: {
      "click": function($event) {
        _vm.enableFullSceen()
      }
    }
  }), _vm._v(" "), (!_vm.isThumbnailVideoLoaded) ? _c('div', {
    staticClass: "loading-status"
  }, [_vm._v("\n                Loading...\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "video-info",
    class: {
      'playback': _vm.tabs[_vm.selectedTabIndex] === 'playback'
    }
  }, [_c('div', {
    staticClass: "info-title",
    on: {
      "click": function($event) {
        _vm.toggleTab()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.isRecordingVideoActive ? _vm.tabs[_vm.selectedTabIndex] : (+_vm.thumbnailVideoPlaybackRates[_vm.thumbnailVideoDefaultPlaybackRateIndex] * 10 * 60) + 'x') + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "info-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.isThumbnailVideoLoaded ? _vm.hours[_vm.selectedHourIndex] + ':' + _vm.minutes[_vm.selectedMinuteIndex] + ':00 ' + _vm.getAmPm(_vm.selectedHourIndex) : 'loading...') + "\n                ")])]), _vm._v(" "), (_vm.isThumbnailVideoLoaded) ? _c('div', {
    staticClass: "playback-control-container"
  }, [_c('div', {
    staticClass: "control-btn"
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0V0z",
      "id": "a"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "b"
    }
  }, [_c('use', {
    attrs: {
      "overflow": "visible",
      "xlink:href": "#a"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "clip-path": "url(#b)",
      "d": "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-btn",
    on: {
      "click": function($event) {
        _vm.onClickFastRewind()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-btn",
    on: {
      "click": function($event) {
        _vm.onClickPlayAndPause()
      }
    }
  }, [(!_vm.isThumbnailVideoPaused) ? _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })]) : _c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 5v14l11-7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-btn",
    on: {
      "click": function($event) {
        _vm.onClickFastForward()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control-btn"
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M24 24H0V0h24v24z",
      "id": "a"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "b"
    }
  }, [_c('use', {
    attrs: {
      "overflow": "visible",
      "xlink:href": "#a"
    }
  })]), _vm._v(" "), _c('path', {
    attrs: {
      "clip-path": "url(#b)",
      "d": "M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
    }
  })])])]) : _vm._e()])])], 1) : _vm._e()])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFullSceenActive),
      expression: "!isFullSceenActive"
    }],
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "camera-control-container"
  }, [(_vm.currentCamera.thumbnailVideos) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabs[_vm.selectedTabIndex] === 'playback'),
      expression: "tabs[selectedTabIndex] === 'playback'"
    }],
    staticClass: "timeline-container"
  }, [_c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n               \n            "), _c('h-scroll-comp', {
    attrs: {
      "refreshTrigger": _vm.refreshHScrollCompCount,
      "itemWidth": 100,
      "selectedItem": _vm.selectedDateIndex,
      "totalItems": _vm.dates.length
    }
  }, _vm._l((_vm.dates), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        'selected': index === _vm.selectedDateIndex,
          'has-recording': _vm.thumbnailVideo(_vm.currentCamera.thumbnailVideos[value])
      },
      on: {
        "click": function($event) {
          _vm.onClickDate(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(value) + "\n              ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n               \n            "), _c('h-scroll-comp', {
    attrs: {
      "refreshTrigger": _vm.refreshHScrollCompCount,
      "itemWidth": 100,
      "selectedItem": _vm.selectedHourIndex,
      "totalItems": _vm.hours.length
    }
  }, _vm._l((_vm.hours), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        selected: index === _vm.selectedHourIndex
      },
      on: {
        "click": function($event) {
          _vm.onClickHour(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(value + _vm.getAmPm(index)) + "\n              ")])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "dates-container"
  }, [_vm._v("\n               \n            "), _c('h-scroll-comp', {
    attrs: {
      "refreshTrigger": _vm.refreshHScrollCompCount,
      "itemWidth": 100,
      "selectedItem": _vm.selectedMinuteIndex,
      "totalItems": _vm.minutes.length
    }
  }, _vm._l((_vm.minutes), function(value, index) {
    return _c('div', {
      key: value,
      staticClass: "date",
      class: {
        selected: index === _vm.selectedMinuteIndex
      },
      on: {
        "click": function($event) {
          _vm.onClickMinute(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(value) + "\n              ")])
  }))], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-btns"
  }, _vm._l((_vm.tabs), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "action-btn",
      class: {
        'selected': index === _vm.selectedTabIndex,
          'playback': value === 'playback'
      },
      on: {
        "click": function($event) {
          _vm.selectTab(index)
        }
      }
    }, [_vm._v(_vm._s(value))])
  }))])])])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "moveup",
      "mode": "out-in",
      "appear": ""
    }
  }, [(!_vm.isHistoryVisible) ? _c('div', {
    key: 'historyInvisible',
    staticClass: "body"
  }, [_c('div', {
    staticClass: "search-input-container"
  }, [_vm._l((_vm.mySites), function(site, siteId) {
    return _c('div', {
      key: siteId,
      staticClass: "instruction-text",
      on: {
        "click": function($event) {
          _vm.getSiteCameras(siteId)
        }
      }
    }, [_vm._v(_vm._s(site.name))])
  }), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    staticClass: "mac-input",
    attrs: {
      "type": "text",
      "placeholder": "Enter mac address"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.goToHome()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "connect-btn",
    on: {
      "click": function($event) {
        _vm.test()
      }
    }
  }, [_c('svg', {
    attrs: {
      "fill": "#FFFFFF",
      "height": "48",
      "viewBox": "0 0 24 24",
      "width": "48",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "action-btns"
  }, [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        _vm.showHistory()
      }
    }
  }, [_vm._v("View history")])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.isHistoryVisible) ? _c('div', {
    key: 'historyVisible',
    staticClass: "body"
  }, [_c('div', {
    staticClass: "search-input-container"
  }, [_c('div', {
    staticClass: "history-container"
  }, [_c('div', {
    staticClass: "description-text"
  }, [_vm._v("Recently connected...")]), _vm._v(" "), _c('div', {
    staticClass: "bridges"
  }, _vm._l((_vm.mockupMacAddresses), function(mac, index) {
    return (index < 5) ? _c('div', {
      key: mac,
      staticClass: "bridge-btn",
      on: {
        "click": function($event) {
          _vm.goToHome()
        }
      }
    }, [_vm._v(_vm._s(mac))]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "action-btns"
  }, [_c('div', {
    staticClass: "action-btn",
    on: {
      "click": function($event) {
        _vm.hideHistory()
      }
    }
  }, [_vm._v("Hide history")])])])]) : _vm._e()])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "logo-text"
  }, [_vm._v("CHeKT Bridge")])])
}]}

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-toaster"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, _vm._l((_vm.toasterItems), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "toaster-wrapper"
    }, [_c('div', {
      staticClass: "toaster",
      class: {
        'success': item.status === 'success',
          'info': item.status === 'info',
          'warning': item.status === 'warning',
          'error': item.status === 'error',
      },
      on: {
        "click": function($event) {
          _vm.onClickToaster(key)
        }
      }
    }, [_c('div', {
      staticClass: "message"
    }, [_vm._v(_vm._s(item.message))])])])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-menu"
  }, [_c('div', {
    staticClass: "menu-items"
  }, [_c('div', {
    staticClass: "menu-category"
  }, [_vm._v("Site")]), _vm._v(" "), _vm._l((_vm.mySites), function(site, siteId) {
    return _c('div', {
      key: siteId,
      staticClass: "menu-item",
      attrs: {
        "ontouchstart": ""
      },
      on: {
        "click": function($event) {
          _vm.selectSite(siteId)
        }
      }
    }, [_c('div', {
      staticClass: "menu-icon"
    }, [_c('svg', {
      attrs: {
        "fill": "#FFFFFF",
        "height": "48",
        "viewBox": "0 0 24 24",
        "width": "48",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "menu-info"
    }, [_c('div', {
      staticClass: "main-info"
    }, [_vm._v(_vm._s(site.name))]), _vm._v(" "), _c('div', {
      staticClass: "sub-info"
    }, [_vm._v(_vm._s(site.address))])])])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[172]);


// WEBPACK FOOTER //
// static/js/app.d4842384b124993ddc5b.js